import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormField } from '../../../../dto/util/form-field';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TramiteSicService } from '../../../../services/tramite-sic.service';
import { AsuntoTramiteConstants, TipoTramiteConstants } from '../../../../constants/tipo-tramite.constants';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { Constants } from '../../../../constants/constants';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { InfoPantallaDTO } from '../../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../../services/util.service';
import { ListasService } from '../../../../services/listas.service';
import { TipoDocumentoDto } from '../../../../dto/expediente/tipo-documento.dto';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { TramiteSicCompetenciaDeslealDto } from '../../../../dto/tramites/tramite-sic-competencia-desleal.dto';
import { ListaValorService } from '../proteccion-al-consumidor/services/lista-valor.service';
import { PersonaConsultadaDTO } from '../../../../dto/tramites/sic/persona-consultada-dto';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TramiteService } from '../../../../services/tramite.service';
import { TramiteDTO } from '../../models/tramiteDTO';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { Location } from '@angular/common';
import { combineLatest, firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { DatosAdicionalesService } from '../../../util/modal-datos/services/datos-adicionales.service';
import { ClaseSolicitudDto } from "../../../../dto/expediente/clase-solicitud-dto.dto";
import { ConfigurarCuentasService } from '../../../configuracion-cuenta/services/configurar-cuentas.service';
import { LanguageService } from '../../../../services/util/language.service';
import { FormComponent } from '../../../util/form/form.component';
declare function nextItemAdvanceLineIHorizonal(event: any): void;

@Component({
  selector: 'app-competencia-desleal',
  templateUrl: './competencia-desleal.component.html',
  styleUrls: ['./competencia-desleal.component.scss'],
})
export class CompetenciaDeslealComponent implements OnInit, OnDestroy {
  idiomaActual: string = 'es';
  // 1. Declaración de propiedades
  @Output() submitAction = new EventEmitter<FormGroup>();

  activeTabIndexDemandantes = 0;
  activeTabIndexDemandados = 0;

  idTramite!: number | null;

  formGroupButton!: FormGroup;
  enviarDocumentos = false;
  dataUsuario: PersonaLoginDTO | undefined;
  entidadId = Constants.ID_ENTIDAD_SIC;

  /* 📌 validacion de formularios enviados */

  tipoPersonaDemandante!: number;
  tipoPersonaDemandado!: number;
  idTramiteObtentorCompentenciaDesleal!: number;
  tipoTramite: number = TipoTramiteConstants.ID_TRAMITE_SIC_PROIND_COMDES;

  /* 📌 Validación de formularios */
  tipoClaseSolicitudValida = false;
  tipoPersonaDemandanteValida = false;
  personaDemandanteNaturalValida = false;
  personaDemandanteJuridicoValida = false;
  apoderadoValida = false;
  tipoDemandadoValida = false;
  direccionDomicilioValida = false;
  personaDemandadoNaturalValida = false;
  personaDemandadoJuridicoValida = false;
  onDemandado = true;
  onDemandante = true;
  onApoderado = true;
  /* 📌 Declararion de FormsGroup */
  formGroupClaseSolicitud!: FormGroup;
  formGroupTipoPersonaDemandante!: FormGroup;
  formGroupDemandanteNatural!: FormGroup;
  formGroupDemandanteJuridico!: FormGroup;
  formGroupApoderado!: FormGroup;
  formGroupTipoDemandado!: FormGroup;
  formGroupDireccionDomicilio!: FormGroup;
  formGroupDemandado!: FormGroup;

  /* 📌 Declararion de FormArray */
  DemandanteArray!: FormArray;
  DemandadoArray!: FormArray;

  /* 📌 Formularios */
  formClaseSolicitud: FormField[] = [];
  formTipoDemandante: FormField[] = [];
  formDemandante: FormField[][] = [];
  formDemandanteNatural: FormField[] = [];
  formDemandanteJuridico: FormField[] = [];
  formApoderado: FormField[] = [];
  formDemandado: FormField[][] = [];
  formTipoDemandado: FormField[] = [];
  formDireccionDomicilio: FormField[] = [];

  dominios: TipoDocumentoDto[] = [];
  paises: PaisDto[] = [];

  demandantes: any[] = [];
  deshabilitarAddDemandante: boolean = true;

  demandados: any[] = [];
  deshabilitarAddDemandados: boolean = true;

  isSaveDemandado: boolean = false;
  isSaveDemandante: boolean = false;

  isApoderadoValido = true;
  archivosCargados: ArchivoItemDto[] = [];
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  listaClaseSolicitud: ClaseSolicitudDto[] = []

  /**precarge de datos */
  asunto: any;
  claseSolicitud: { id?: number; nombre?: string; estado?: boolean } = {};
  apoderadoPrecarga!: TramiteDTO['apoderado'];
  demandantesPrecarga: any = [];
  demandadosPrecarga: any = [];
  idTramitePrecarga: number | null = null;

  // Formulatios
  mostrarComponenteCarga: boolean = true;
  archivosPreCargados?: AnexoPrecargaResponseDto[];
  submitFinalizar: boolean = false;
  cargoArchivo: boolean = false;
  enviarEntidad: boolean = false;

  // Multilenguaje
  sicText: any = {};
  comunText: any = {};
  alertaText: any = {};

  // seteo inputs otro Departamento y municipio
  auxIdCountryDemandante: number[] = [];
  auxIdCountryRlDemandante: number[] = [];
  auxIdCountryDemandado: number[] = [];
  auxIdCountryRlDemandado: number[] = [];
  auxIdCountryApoderado: number[] = [];

  // Existe persona
  existePersonaDemandante: boolean = false;
  existePersonaDemandado: boolean = false;
  existePersonaApoderada: boolean = false;

  confirmacionEnvio: boolean = false;
  enviarCorreoDemandado: boolean = false;
  pesoTotalArchivosMB: string = '0.00';
  pesoTotalGB: number = 0;
  valorMaximoGB: number = Constants.TAMANIO_MAXIMO_ARCHIVOS_GBYTES;
  nombreCortoLimpio = '';
  nombreCompleto = '';
  tituloKey: string = 'titulo';
  seleccionAceptoRechazoEnvio = false;
  proceso: string = '';
  entidad: string = '';

  @ViewChildren('DemandanteComponent') demandanteComponentes!: QueryList<FormComponent>;
  @ViewChildren('DemandadoComponent') demandadoComponentes!: QueryList<FormComponent>;

  // 2. Constructor
  constructor(
    private readonly fb: FormBuilder,
    private readonly tramiteSicService: TramiteSicService,
    private readonly utilService: UtilService,
    private readonly listasService: ListasService,
    private readonly alertaModalService: AlertaModalService,
    private readonly serviceLista: ListaValorService,
    private readonly router: Router,
    private readonly spinner: NgxSpinnerService,
    private readonly tramiteService: TramiteService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly _cuentaService: ConfigurarCuentasService,
    private languageService: LanguageService,
  ) { }



  // 3. Ciclo de vida
  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    const nombreCorto = sessionStorage.getItem('tramiteSeleccionado');
    const nombreCompleto = sessionStorage.getItem('nombreTramite');
    if (nombreCorto && nombreCompleto) {
      this.nombreCortoLimpio = nombreCorto.trim().replace(/^"|"$/g, '').toUpperCase();
      this.nombreCompleto = nombreCompleto.trim().replace(/^"|"$/g, '');
      this.asignarTituloKey();
    }
    this.tramiteService.obtenerNombreEntidadPorIdNombreCorto(2, this.nombreCortoLimpio).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });

    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      const formattedCountries = countries.map(country => ({
        Id: country.Id,
        Nombre: country.Nombre,
        Codigo: country.Codigo,
      }));
      this.paises = formattedCountries;
    });
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.sicText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      // Construir formularios después de cargar traducciones
      this.buildForms();
      this.filtrarAsuntosPorNombreCorto();
    });
    this.initializeFormGroups();
    this.formGroupButton = this.fb.group({
      DemandanteArray: this.DemandanteArray,
      DemandadoArray: this.DemandadoArray,
    });
    setTimeout(() => {
      this.formClaseSolicitud = this.formClaseSolicitud.map(field => {
        if (field.name === 'claseOfSolicitation' && field.options?.length) {
          const filteredOptions =
            field.options?.filter(option => option.Id !== 5) || [];
          return { ...field, options: filteredOptions };
        }
        return field;
      });
    }, 1000);
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        infoInicioSesion.idUsuario,
        this.setIdTipoTramite(Constants.MAPA_NOMBRE_CORTO_A_ID[this.nombreCortoLimpio])
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.mostrarComponenteCarga = false;
              this.idTramitePrecarga = resp.Id;
              this.consultarTramitePorID(resp.Id);
              // this.dataUsuario = undefined;
            },
            () => {
              this.idTramite = null;
              // this.dataUsuario = JSON.parse(
              //   sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
              // );
              setTimeout(() => {
                this.getData();
              }, 2000);
            },
            true
          );
        } else {
          this.idTramite = null;
          this.dataUsuario = JSON.parse(
            sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
          );
          setTimeout(() => {
            this.getData();
          }, 2000);
        }
      });

    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de competencia desleal y propiedad industrial en la entidad ' +
        'Superintendencia de Industria y Comercio',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un Proceso de competencia desleal y propiedad industrial en la ' +
        'Superintendencia de Industria y Comercio',
      pasos: [],
      // Evento en el botón volver
      change: async op =>
        await this.guardarAntesDeSalir(
          this.alertaModalService,
          this.location,
          op
        ),
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
    this.getTypeDocuments();
    this.getListas();
    setTimeout(() => {
      this.getListaDocumentosApoderado();
    }, 1000);
  }

  // Función para mostrar alerta antes de salir de la pantalla
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.callServiceCrearTramite();
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {

          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  ngOnDestroy() {
    // window.removeEventListener('beforeunload', this.unloadNotification);
  }

  // Se consume el servicio de consultar el detalle del trámite según el ID
  consultarTramitePorID(id: number) {
    this.idTramite = id;
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          if (resp.anexos) {
            this.archivosPreCargados = resp.anexos;
            this.mostrarComponenteCarga = true;
            this.cargoArchivo = resp.anexos.length > 0;
          }
          this.claseSolicitud = resp.claseSolicitud;
          this.asunto = resp.asunto;
          this.formClaseSolicitud = this.formClaseSolicitud.map(
            (field: FormField) => {
              if (field.name == 'claseOfSolicitation') {
                if (this.claseSolicitud.id != undefined) {
                  field.value = this.claseSolicitud.id;
                }
              } else if (field.name == 'asuntoField') {
                if (this.asunto.id != undefined) {
                  field.value = this.asunto.id;
                }
              }
              return field;
            }
          );
          if (
            this.claseSolicitud.id != undefined &&
            this.asunto.id != undefined
          ) {
            this.tipoClaseSolicitudValida = true;
          }
          if (resp.apoderado) {
            this.apoderadoPrecarga = resp.apoderado;
            this.formApoderado = this.formApoderado.map((field: FormField) => {
              switch (field.name) {
                case 'typeOfDocument':
                  field.value = resp.apoderado.idTipoIdentificacion;
                  break;
                case 'numberOfDocument':
                  field.value = resp.apoderado.identificacion;
                  break;
                case 'primerNombre':
                  field.value = resp.apoderado.primerNombre;
                  break;
                case 'segundoNombre':
                  field.value = resp.apoderado.segundoNombre;
                  break;
                case 'primerApellido':
                  field.value = resp.apoderado.primerApellido;
                  break;
                case 'segundoApellido':
                  field.value = resp.apoderado.segundoApellido;
                  break;
                case 'address':
                  if (
                    resp.apoderado.direccionPersona &&
                    Array.isArray(resp.apoderado.direccionPersona) &&
                    resp.apoderado.direccionPersona.length > 0 &&
                    resp.apoderado.direccionPersona[0].direccionNotificacion !==
                    undefined
                  ) {
                    field.value =
                      resp.apoderado.direccionPersona[0].direccionNotificacion;
                  } else {
                    field.value = undefined;
                  }

                  break;
                case 'country':
                  this.formGroupApoderado
                    .get('country')
                    ?.setValue(resp.apoderado.municipio.idPais);
                  field.value = resp.apoderado.municipio.idPais;
                  break;
                case 'departament':
                  field.value = resp.apoderado.municipio.idDepartamento;
                  break;
                case 'municipality':
                  field.value = resp.apoderado.municipio.id;
                  break;
                case 'otroMunicipioApoderado':
                  field.value = resp.apoderado.ciudadExtranjero;
                  break;
                case 'otroDepartamentoApoderado':
                  field.value = resp.apoderado.departamentoExtranjero;
                  break;
                case 'professionalCard':
                  field.value = resp.apoderado.tarjetaProfesional!;
                  break;
                case 'email':
                  field.value = resp.apoderado.correoElectronico;
                  break;
              }
              return field;
            });
            this.validarFormApoderado(
              this.formGroupApoderado
            );
          }
          // Demandantes
          this.demandantesPrecarga = resp.demandante;
          let indexDemandantes = 0;

          while (indexDemandantes < this.demandantesPrecarga.length) {
            const demandante: PersonaDto =
              this.demandantesPrecarga[indexDemandantes];

            const basePersona: PersonaDto = {
              id: demandante.id,
              tipoPersonaDemandante: +demandante.idTipoPersona!,
              typeOfDocument: +demandante.idTipoIdentificacion!,
              numeroOfDocument: demandante.identificacion!,
              correoElectronico: demandante.correoElectronico,
              country: demandante.municipio?.idPais,
              departament: demandante.municipio?.idDepartamento,
              municipality: demandante.municipio?.id,
              otroDepartamento: demandante.departamentoExtranjero ?? '',
              otroMunicipio: demandante.ciudadExtranjero ?? '',
              direccionPersona: [
                {
                  direccionNotificacion:
                    demandante.direccionPersona?.[0]?.direccionNotificacion,
                },
              ],
            };

            if (demandante.idTipoPersona === Constants.TIPO_PERSONA.NATURAL) {
              const personaNatural: PersonaDto = {
                ...basePersona,
                primerNombre: demandante.primerNombre,
                segundoNombre: demandante.segundoNombre,
                primerApellido: demandante.primerApellido,
                segundoApellido: demandante.segundoApellido,
              };
              this.mapearFormularioDemandantes(
                personaNatural,
                indexDemandantes
              );
              this.guardarDemandantePrecarga(personaNatural, true);
              this.inicializarFormDemandante();
              this.DemandanteArray.push(this.createDemandanteNaturalForm());
              this.tipoPersonaDemandante = 1;
              // this.personaDemandanteNaturalValida = true;
              this.showObligation('naturalDemandante', indexDemandantes, 0);
            } else {
              const personaJuridica: PersonaDto = {
                ...basePersona,
                razonSocial: demandante.razonSocial,
                typeOfDocumentRl:
                  demandante.datosRepresentanteLegal?.idTipoIdentificacion,
                numeroOfDocumentRl:
                  demandante.datosRepresentanteLegal?.identificacion!,
                firstNameRl: demandante.datosRepresentanteLegal?.primerNombre,
                secondNameRl: demandante.datosRepresentanteLegal?.segundoNombre,
                firstLastNameRl:
                  demandante.datosRepresentanteLegal?.primerApellido,
                secondLastNameRl:
                  demandante.datosRepresentanteLegal?.segundoApellido,
                addressRl: [
                  {
                    direccionNotificacion:
                      demandante.datosRepresentanteLegal?.direccionPersona?.[0]
                        ?.direccionNotificacion,
                  },
                ],
                countryRl:
                  demandante.datosRepresentanteLegal?.municipio?.idPais,
                departamentRl:
                  demandante.datosRepresentanteLegal?.municipio?.idDepartamento,
                municipalityRl:
                  demandante.datosRepresentanteLegal?.municipio?.id,
                otroDepartamentoRl:
                  demandante.datosRepresentanteLegal?.departamentoExtranjero ??
                  '',
                otroMunicipioRl:
                  demandante.datosRepresentanteLegal?.ciudadExtranjero ?? '',
                emailRl: demandante.datosRepresentanteLegal?.correoElectronico,
              };
              this.mapearFormularioDemandantes(
                personaJuridica,
                indexDemandantes
              );
              const representanteLegalNormalizado: PersonaDto = {
                idTipoIdentificacion:
                  demandante.datosRepresentanteLegal?.idTipoIdentificacion!,
                identificacion:
                  demandante.datosRepresentanteLegal?.identificacion!,
                primerNombre: demandante.datosRepresentanteLegal?.primerNombre,
                segundoNombre:
                  demandante.datosRepresentanteLegal?.segundoNombre,
                primerApellido:
                  demandante.datosRepresentanteLegal?.primerApellido,
                segundoApellido:
                  demandante.datosRepresentanteLegal?.segundoApellido,
                direccionPersona: [
                  {
                    direccionNotificacion:
                      demandante.datosRepresentanteLegal?.direccionPersona?.[0]
                        ?.direccionNotificacion,
                  },
                ],
                country: demandante.datosRepresentanteLegal?.municipio?.idPais,
                departament:
                  demandante.datosRepresentanteLegal?.municipio?.idDepartamento,
                municipio: {
                  id: demandante.datosRepresentanteLegal?.municipio?.id,
                },
                departamentoExtranjero:
                  demandante.datosRepresentanteLegal?.departamentoExtranjero,
                ciudadExtranjero:
                  demandante.datosRepresentanteLegal?.ciudadExtranjero,
                correoElectronico:
                  demandante.datosRepresentanteLegal?.correoElectronico,
                id: demandante.datosRepresentanteLegal?.id,
              };
              const personaJuridicaNormalizada: PersonaDto = {
                ...basePersona,
                razonSocial: demandante.razonSocial,
                datosRepresentanteLegal: representanteLegalNormalizado,
              };
              this.guardarDemandantePrecarga(personaJuridicaNormalizada, false);
              this.inicializarFormDemandante();
              this.DemandanteArray.push(this.createDemandanteJuridicoForm());
              this.tipoPersonaDemandante = 2;
              // this.personaDemandanteJuridicoValida = true;
              this.showObligation('juridicoDemandante', indexDemandantes, 0);
            }

            // Incrementamos el índice
            indexDemandantes++;
          }
          if (this.DemandanteArray.length > 1) {
            this.removeDemandanteForm(this.DemandanteArray.length - 1, false, true);
          }
          this.demandantes = this.cambiarNombrePropiedad(
            this.demandantes,
            true
          );
          // Demandados
          this.demandadosPrecarga = resp.demandado;
          let indexDemandados = 0;

          while (indexDemandados < this.demandadosPrecarga.length) {
            const demandado: PersonaDto =
              this.demandadosPrecarga[indexDemandados];

            let basePersona: PersonaDto = {
              id: demandado.id,
              tipoPersonaDemandado: +demandado.idTipoPersona!,
              typeOfDocument: +demandado.idTipoIdentificacion!,
              numeroOfDocument: demandado.identificacion!,
              correoElectronico: demandado.correoElectronico,
              country: demandado.municipio?.idPais,
              departament: demandado.municipio?.idDepartamento,
              municipality: demandado.municipio?.id,
              otroDepartamento: demandado.departamentoExtranjero ?? '',
              otroMunicipio: demandado.ciudadExtranjero ?? '',
              direccionPersona: [
                {
                  direccionNotificacion:
                    demandado.direccionPersona?.[0]?.direccionNotificacion,
                },
              ],
            };
            let tieneDomicilio: boolean =
              !!demandado.direccionPersona?.[0]?.direccionNotificacion;

            basePersona.direccionDomicilio = tieneDomicilio ? 1 : 2;

            if (demandado.idTipoPersona === Constants.TIPO_PERSONA.NATURAL) {
              const personaNatural: PersonaDto = {
                ...basePersona,
                primerNombre: demandado.primerNombre,
                segundoNombre: demandado.segundoNombre,
                primerApellido: demandado.primerApellido,
                segundoApellido: demandado.segundoApellido,
              };
              this.mapearFormularioDemandados(personaNatural, indexDemandados);
              this.guardarDemandadoPrecarga(
                personaNatural,
                true,
                tieneDomicilio
              );
              this.inicializarFormDemandado();
              this.DemandadoArray.push(
                this.createDemandadoNaturalConoceDomicilioForm()
              );
              this.personaDemandadoNaturalValida = true;
              this.showObligation('naturalDemandado', indexDemandados, 0);
            } else {
              const personaJuridica: PersonaDto = {
                ...basePersona,
                razonSocial: demandado.razonSocial,
                typeOfDocumentRl:
                  +demandado.datosRepresentanteLegal?.idTipoIdentificacion!,
                numeroOfDocumentRl:
                  demandado.datosRepresentanteLegal?.identificacion!,
                firstNameRl: demandado.datosRepresentanteLegal?.primerNombre,
                secondNameRl: demandado.datosRepresentanteLegal?.segundoNombre,
                firstLastNameRl:
                  demandado.datosRepresentanteLegal?.primerApellido,
                secondLastNameRl:
                  demandado.datosRepresentanteLegal?.segundoApellido,
                addressRl: [
                  {
                    direccionNotificacion:
                      demandado.datosRepresentanteLegal?.direccionPersona?.[0]
                        ?.direccionNotificacion,
                  },
                ],
                countryRl: demandado.datosRepresentanteLegal?.municipio?.idPais,
                departamentRl:
                  demandado.datosRepresentanteLegal?.municipio?.idDepartamento,
                municipalityRl:
                  demandado.datosRepresentanteLegal?.municipio?.id,
                otroDepartamentoRl:
                  demandado.datosRepresentanteLegal?.departamentoExtranjero ??
                  '',
                otroMunicipioRl:
                  demandado.datosRepresentanteLegal?.ciudadExtranjero ?? '',
                emailRl: demandado.datosRepresentanteLegal?.correoElectronico,
              };
              this.mapearFormularioDemandados(personaJuridica, indexDemandados);
              const representanteLegalNormalizado: PersonaDto = {
                idTipoIdentificacion:
                  demandado.datosRepresentanteLegal?.idTipoIdentificacion!,
                identificacion:
                  demandado.datosRepresentanteLegal?.identificacion!,
                primerNombre: demandado.datosRepresentanteLegal?.primerNombre,
                segundoNombre: demandado.datosRepresentanteLegal?.segundoNombre,
                primerApellido:
                  demandado.datosRepresentanteLegal?.primerApellido,
                segundoApellido:
                  demandado.datosRepresentanteLegal?.segundoApellido,
                direccionPersona: [
                  {
                    direccionNotificacion:
                      demandado.datosRepresentanteLegal?.direccionPersona?.[0]
                        ?.direccionNotificacion,
                  },
                ],
                country: demandado.datosRepresentanteLegal?.municipio?.idPais,
                departament:
                  demandado.datosRepresentanteLegal?.municipio?.idDepartamento,
                municipio: {
                  id: demandado.datosRepresentanteLegal?.municipio?.id,
                },
                departamentoExtranjero:
                  demandado.datosRepresentanteLegal?.departamentoExtranjero,
                ciudadExtranjero:
                  demandado.datosRepresentanteLegal?.ciudadExtranjero,
                correoElectronico:
                  demandado.datosRepresentanteLegal?.correoElectronico,
                id: demandado.datosRepresentanteLegal?.id,
              };
              const personaJuridicaNormalizada: PersonaDto = {
                ...basePersona,
                razonSocial: demandado.razonSocial,
                datosRepresentanteLegal: representanteLegalNormalizado,
              };
              this.guardarDemandadoPrecarga(
                personaJuridicaNormalizada,
                false,
                tieneDomicilio
              );
              this.inicializarFormDemandado();
              this.DemandadoArray.push(
                this.createDemandadoNaturalConoceDomicilioForm()
              );
              this.personaDemandadoJuridicoValida = true;
              this.showObligation(
                'juridicoDemandado',
                indexDemandados,
                tieneDomicilio == true ? 1 : 2
              );
            }

            // Incrementamos el índice
            indexDemandados++;
          }
          if (this.DemandadoArray.length > 1) {
            this.removeDemandadoForm(this.DemandadoArray.length - 1, false, true);
          }
          this.demandados = this.cambiarNombrePropiedad(this.demandados, false);
        }
      });
  }

  mapearFormularioDemandantes(persona: PersonaDto, index: number) {
    setTimeout(() => {
      this.formDemandante[index] = this.formDemandante[index].map(field => {
        let value = persona[field.name as keyof typeof persona];
        if (field.name === 'otroDepartamentoDemandante') {
          value = persona['otroDepartamento'];
        }
        if (field.name === 'otroMunicipioDemandante') {
          value = persona['otroMunicipio'];
        }
        if (field.name === 'otroDepartamentoDemandanteRl') {
          value = persona['otroDepartamentoRl'];
        }
        if (field.name === 'otroMunicipioDemandanteRl') {
          value = persona['otroMunicipioRl'];
        }
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[0]?.direccionNotificacion;
        }
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          field.value = value;
        }
        return field;
      });
    }, 100);
    this.formDemandante[index].forEach((field: FormField) => {
      let value = persona[field.name as keyof typeof persona];
      if (persona['tipoPersonaDemandante'] == 1) {
        if (
          field.name == 'typeOfDocument' ||
          field.name == 'numeroOfDocument'
        ) {
          if (
            value !== undefined &&
            value !== null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'boolean')
          ) {
            field.value = value;
          }
        }
      }
    });
  }

  mapearFormularioDemandados(persona: PersonaDto, index: number) {
    setTimeout(() => {
      this.formDemandado[index] = this.formDemandado[index].map(field => {
        let value = persona[field.name as keyof typeof persona];
        if (field.name === 'otroDepartamentoDemandado') {
          value = persona['otroDepartamento'];
        }
        if (field.name === 'otroMunicipioDemandado') {
          value = persona['otroMunicipio'];
        }
        if (field.name === 'otroDepartamentoDemandadoRl') {
          value = persona['otroDepartamentoRl'];
        }
        if (field.name === 'otroMunicipioDemandadoRl') {
          value = persona['otroMunicipioRl'];
        }
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[0]?.direccionNotificacion;
        }
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          field.value = value;
        }
        return field;
      });
    }, 1000);
    this.formDemandado[index].forEach((field: FormField) => {
      let value = persona[field.name as keyof typeof persona];
      if (persona['tipoPersonaDemandado'] == 1) {
        if (
          field.name == 'typeOfDocument' ||
          field.name == 'numeroOfDocument'
        ) {
          if (
            value !== undefined &&
            value !== null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'boolean')
          ) {
            field.value = value;
          }
        }
      }
    });
  }

  cambiarNombrePropiedad(
    array: PersonaDto[],
    isDemandante: boolean
  ): PersonaDto[] {
    return array.map(objeto => {
      // Creamos un nuevo objeto con las mismas propiedades
      const nuevoObjeto = { ...objeto };

      // Cambiamos el nombre de la propiedad
      if (isDemandante) {
        if (nuevoObjeto.tipoPersonaDemandante !== undefined) {
          nuevoObjeto.idTipoPersona = nuevoObjeto.tipoPersonaDemandante;
          delete nuevoObjeto.tipoPersonaDemandante;
        }
      } else {
        if (nuevoObjeto.tipoPersonaDemandado !== undefined) {
          nuevoObjeto.idTipoPersona = nuevoObjeto.tipoPersonaDemandado;
          delete nuevoObjeto.tipoPersonaDemandado;
        }
      }
      return nuevoObjeto;
    });
  }

  // 4. Otros métodos
  /* 📌 Metodo para inicializacion de grupos de formularios */
  initializeFormGroups() {
    this.formGroupClaseSolicitud = this.fb.group({
      formClaseSolicitud: ['', Validators.required],
    });
    this.formGroupTipoPersonaDemandante = this.fb.group({
      formTipoDemandante: ['', Validators.required],
    });
    this.formGroupDemandanteNatural = this.fb.group({
      formDemandanteNatural: ['', Validators.required],
    });
    this.formGroupDemandanteJuridico = this.fb.group({
      formDemandanteJuridico: ['', Validators.required],
    });
    this.formGroupApoderado = this.fb.group({
      formApoderado: ['', Validators.required],
    });
    this.formGroupTipoDemandado = this.fb.group({
      formTipoDemandado: ['', Validators.required],
    });
    this.formGroupDireccionDomicilio = this.fb.group({
      formDireccionDomicilio: ['', Validators.required],
    });
    this.formGroupDemandado = this.fb.group({
      formDemandado: ['', Validators.required],
    });
  }

  /* 📌 Metodo para construccion Formularios */
  buildForms() {
    this.DemandanteArray = this.fb.array([this.createDemandanteNaturalForm()]);
    this.DemandadoArray = this.fb.array([
      this.createDemandadoNaturalConoceDomicilioForm(),
    ]);
    this.formClaseSolicitud = [
      {
        name: 'claseOfSolicitation',
        label: this.comunText['clase-solicitud'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required:
            this.sicText['tramite-sic-comp-desleal'][
            'clase-solicitud-required'
            ],
        },
      },
      {
        name: 'asuntoField',
        label: this.sicText['tramite-sic-comp-desleal']['asunto'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        value: Constants.MAPA_NOMBRE_CORTO_A_ID[this.nombreCortoLimpio],
        errorMessages: {
          required: this.sicText['tramite-sic-comp-desleal']['asunto-required'],
        },
      },
    ];
    this.formApoderado = [
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
        },
      },
      {
        name: 'address',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamentoApoderado',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.sicText['tramite-sic-comp-desleal']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioApoderado',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sicText['tramite-sic-comp-desleal']['campo-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sicText['tramite-sic-comp-desleal']['escriba-municipio'],
      },
      {
        name: 'professionalCard',
        label: this.comunText['tarjeta-profesional'],
        type: 'text',
        required: true,
        placeholder: this.comunText['tarjeta-profesional-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['tarjeta-profesional-required'],
          minlength: this.comunText['tarjeta-profesional-minlength'],
          maxlength: this.comunText['tarjeta-profesional-maxlength'],
          pattern: this.comunText['tarjeta-profesional-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
    this.inicializarFormDemandante();
    this.inicializarFormDemandado();
  }

  inicializarFormDemandante() {
    const demandanteForm: FormField[] = [
      // Data compartida por natural y juridico
      {
        name: 'tipoPersonaDemandante',
        label: this.comunText['tipo-demandante'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['persona-natural-select'] },
          { Id: 2, Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
        typeOfDocumentsDepends: ['typeOfDocument'],
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numeroOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: false,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'direccionPersona',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder: this.comunText['direccion-notificacion-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      // Data compartida por natural y juridico
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        value: 1,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamentoDemandante',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.sicText['tramite-sic-comp-desleal']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandante',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sicText['tramite-sic-comp-desleal']['campo-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sicText['tramite-sic-comp-desleal']['escriba-municipio'],
      },
      {
        name: 'correoElectronico',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      // Representante legal
      {
        isSubtitle: true,
        subtitleText: this.comunText['subtitulo-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: false,
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'typeOfDocumentRl',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        personTypeId: '3',
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'numeroOfDocumentRl',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: false,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: false,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
          pattern: this.comunText['numero-documento-pattern'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'firstNameRl',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'secondNameRl',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'firstLastNameRl',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'secondLastNameRl',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'addressRl',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: false,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: false,
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'countryRl',
        label: this.comunText['country'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['country-required'] },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'departamentRl',
        label: this.comunText['departament'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'municipalityRl',
        label: this.comunText['municipality'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'otroDepartamentoDemandanteRl',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'countryRl',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.sicText['tramite-sic-comp-desleal']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandanteRl',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sicText['tramite-sic-comp-desleal']['campo-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'countryRl',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sicText['tramite-sic-comp-desleal']['escriba-municipio'],
      },
      {
        name: 'emailRl',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: false,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandante',
        visibilityCondition: value => value == 2,
      },
    ];
    this.formDemandante.push(demandanteForm);
  }

  inicializarFormDemandado() {
    const demandadoForm: FormField[] = [
      {
        name: 'tipoPersonaDemandado',
        label:
          this.sicText['tramite-sic-comp-desleal']['tipo-persona-demadado'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['persona-natural-select'] },
          { Id: 2, Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
        typeOfDocumentsDepends: ['typeOfDocument'],
      },
      {
        name: 'direccionDomicilio',
        label: this.sicText['tramite-sic-comp-desleal']['direccion-domicilio'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: this.comunText['opcion-si'] },
          { Id: 2, Nombre: this.comunText['opcion-no'] },
        ],
        width: '12',
        visible: true,
        errorMessages: {
          required:
            this.sicText['tramite-sic-comp-desleal']['respuesta-obligatoria'],
        },
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numeroOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'direccionPersona',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: false,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: false,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        dependsOn: 'direccionDomicilio',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: false,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: value => value == 2,
      },
      {
        name: 'correoElectronico',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        value: this.nombreCortoLimpio === 'SIC_PROIND_COMDES' ? 1 : undefined,
        errorMessages: { required: this.comunText['country-required'] },
        dependsOn: 'direccionDomicilio',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'direccionDomicilio',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'direccionDomicilio',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'otroDepartamentoDemandado',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.sicText['tramite-sic-comp-desleal']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandado',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sicText['tramite-sic-comp-desleal']['campo-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sicText['tramite-sic-comp-desleal']['escriba-municipio'],
      },
      // RL
      {
        isSubtitle: true,
        subtitleText: this.comunText['subtitulo-representante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: false,
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'typeOfDocumentRl',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        personTypeId: '3',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'numeroOfDocumentRl',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: false,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: false,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'firstNameRl',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'secondNameRl',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'firstLastNameRl',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'secondLastNameRl',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
      {
        name: 'addressRl',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: false,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '12',
        visible: false,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) =>
          value == 2 && form?.get('direccionDomicilio')?.value == 1,
      },
      {
        name: 'countryRl',
        label: this.comunText['country'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['country-required'] },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) =>
          value == 2 && form?.get('direccionDomicilio')?.value == 1,
      },
      {
        name: 'departamentRl',
        label: this.comunText['departament'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['departament-required'] },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) =>
          value == 2 && form?.get('direccionDomicilio')?.value == 1,
      },
      {
        name: 'municipalityRl',
        label: this.comunText['municipality'],
        type: 'select',
        required: false,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['municipality-required'] },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) =>
          value == 2 && form?.get('direccionDomicilio')?.value == 1,
      },
      {
        name: 'otroDepartamentoDemandadoRl',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'countryRl',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.sicText['tramite-sic-comp-desleal']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandadoRl',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sicText['tramite-sic-comp-desleal']['campo-required'],
          maxlength:
            this.sicText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'countryRl',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sicText['tramite-sic-comp-desleal']['escriba-municipio'],
      },
      {
        name: 'emailRl',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: false,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: false,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
        dependsOn: 'tipoPersonaDemandado',
        visibilityCondition: (value, form) => value == 2,
      },
    ];
    this.formDemandado.push(demandadoForm);
  }

  // Metodo que filtra el tipo de documentos para apoderado, quitando TI
  getListaDocumentosApoderado() {
    this.formApoderado = this.formApoderado.map((field: FormField) => {
      if (field.name === 'typeOfDocument' && field.options?.length) {
        const filteredOptions =
          field.options?.filter(option => option.Id !== 5) || [];
        return { ...field, options: filteredOptions };
      }
      return field;
    });
  }

  /* listas */
  getTypeDocuments() {
    this.listasService
      .getDocumentTypeList()
      .subscribe((documentTypes: TipoDocumentoDto[]) => {
        this.dominios = documentTypes.map(documentType => ({
          Id: documentType.Id,
          TipoDocumento: documentType.Tipo_Documento,
        }));
      });
  }

  getListas() {
    this.listasService.getRequestClassList()
      .subscribe((lista: ClaseSolicitudDto[]) => {
        this.listaClaseSolicitud = lista
      });
  }


  /* Crear formularios individuales para los demandantes */
  createDemandanteNaturalForm(): FormGroup {
    return this.fb.group({
      idTipoPersona: ['', Validators.required],
      typeOfDocument: ['', Validators.required],
      numberOfDocument: ['', Validators.required],
      primerNombre: ['', Validators.required],
      segundoNombre: [''],
      primerApellido: ['', Validators.required],
      segundoApellido: [''],
      direccionPersona: ['', Validators.required],
      country: ['', Validators.required],
      departament: ['', Validators.required],
      municipality: ['', Validators.required],
      correoElectronico: ['', Validators.required],
      esApoderado: [false],
    });
  }

  createDemandanteJuridicoForm(): FormGroup {
    return this.fb.group({
      idTipoPersona: ['', Validators.required],
      idTipoIdentificacion: ['', Validators.required],
      numberOfDocumentNIT: ['', Validators.required],
      razonSocial: ['', Validators.required],
      country: ['', Validators.required],
      departament: ['', Validators.required],
      municipality: ['', Validators.required],
      email: ['', Validators.required],
      esApoderado: [false],
      idTipoPersonaRL: ['', Validators.required],
      typeOfDocumentRl: ['', Validators.required],
      numberOfDocument: ['', Validators.required],
      firstNameRl: ['', Validators.required],
      secondNameRl: ['', Validators.required],
      firstLastNameRl: ['', Validators.required],
      secondLastNameRl: ['', Validators.required],
      addressRl: ['', Validators.required],
      countryRl: ['', Validators.required],
      departamentRl: ['', Validators.required],
      municipalityRl: ['', Validators.required],
      emailRl: ['', Validators.required],
    });
  }

  createDemandadoNaturalConoceDomicilioForm(): FormGroup {
    return this.fb.group({
      idTipoPersona: ['', Validators.required],
      typeOfDocument: ['', Validators.required],
      numberOfDocument: ['', Validators.required],
      firstName: ['', Validators.required],
      secondName: ['', Validators.required],
      firstLastName: ['', Validators.required],
      secondLastName: ['', Validators.required],
      addressNotificationJudicial: ['', Validators.required],
      country: ['', Validators.required],
      departament: ['', Validators.required],
      municipality: ['', Validators.required],
      emailNotificationJudicial: ['', Validators.required],
    });
  }

  /* Agregar un nuevo demandante o demandado */
  addDemandanteForm() {
    this.isSaveDemandante = false;
    this.onDemandante = true;
    this.deshabilitarAddDemandante = true;
    this.inicializarFormDemandante();
    this.DemandanteArray.push(this.createDemandanteNaturalForm());
    this.setActiveTabDemandantes(this.DemandanteArray.controls.length - 1);
    this.personaDemandanteNaturalValida = false;
    this.personaDemandanteJuridicoValida = false;
  }

  addDemandadoForm() {
    this.isSaveDemandado = false;
    this.onDemandado = true;
    this.deshabilitarAddDemandados = true;
    this.inicializarFormDemandado();
    this.DemandadoArray.push(this.createDemandadoNaturalConoceDomicilioForm());
    this.setActiveTabDemandandos(this.DemandadoArray.controls.length - 1);
  }

  /* �?Eliminar un demandante o demandado */
  removeDemandanteForm(index: number, isDelete: boolean, isPrecargue: boolean) {
    const removeDemandante = () => {
      this.onDemandante = false;
      if (this.DemandanteArray.length > 0) {
        this.DemandanteArray.removeAt(index);
        this.formDemandante.splice(index, 1);
        this.activeTabIndexDemandantes = Math.min(
          index,
          this.DemandanteArray.length - 1
        );
        this.borrarDemandante(index, Constants.TIPO_PERSONA.NATURAL);
        let indice = 0;
        if (this.demandantes.length > 1) {
          indice = this.demandantes.length - 1;
        }
        const esNatural =
          this.demandantes[indice].tipoPersonaDemandante ?
            this.demandantes[indice].tipoPersonaDemandante == Constants.TIPO_PERSONA.NATURAL :
            this.demandantes[indice].idTipoPersona == Constants.TIPO_PERSONA.NATURAL;
        if (!isPrecargue) {
          this.deshabilitarAddDemandante = this.esValidoObligatoriosDemandante(this.demandantes[indice], esNatural);
        }
        this.tipoPersonaDemandante =
          this.demandantes[this.demandantes.length - 1].idTipoPersona!;
        this.isSaveDemandante = true;
        if (this.tipoPersonaDemandante == Constants.TIPO_PERSONA.NATURAL) {
          this.personaDemandanteNaturalValida = true;
        } else {
          this.personaDemandanteJuridicoValida = true;
        }
      } else {
        this.activeTabIndexDemandantes = -1;
        this.personaDemandanteNaturalValida = false;
      }
    };

    if (isDelete) {
      this.alertaModalService.confirmacion(
        this.alertaText['sic-comp-desleal-alertas']['subtitulo-eliminar'],
        this.alertaText['sic-comp-desleal-alertas'][
        'titulo-eliminar-demandante'
        ],
        removeDemandante,
        () => { }
      );
    } else {
      removeDemandante(); // Si no es necesario confirmar, proceder directamente
    }
  }

  removeDemandadoForm(index: number, isDelete: boolean, isPrecargue: boolean) {
    const removeDemandado = () => {
      this.onDemandado = false;
      if (this.DemandadoArray.length > 0) {
        this.DemandadoArray.removeAt(index);
        this.formDemandado.splice(index, 1);
        this.activeTabIndexDemandados = Math.min(
          index,
          this.DemandadoArray.length - 1
        );
        this.borrarDemandado(index, Constants.TIPO_PERSONA.NATURAL, true);
        let indice = 0;
        if (this.demandados.length > 1) {
          indice = this.demandados.length - 1;
        }
        const esNatural =
          this.demandados[indice].tipoPersonaDemandante ?
            this.demandados[indice].tipoPersonaDemandante == Constants.TIPO_PERSONA.NATURAL :
            this.demandados[indice].idTipoPersona == Constants.TIPO_PERSONA.NATURAL;
        const direccion = this.demandados[indice].direccionPersona ? this.demandados[indice].direccionPersona[0].direccionNotificacion ? true : false : false;
        if (!isPrecargue) {
          this.deshabilitarAddDemandados = this.validarCamposDemandado(
            {
              form: this.demandados[indice],
              esNatural: esNatural,
              tieneDomicilio: direccion
            });
        }
        this.isSaveDemandado = true;
        if (esNatural) {
          this.personaDemandadoNaturalValida = true;
        } else {
          this.personaDemandadoJuridicoValida = true;
        }
      } else {
        this.activeTabIndexDemandados = -1;
      }
    };

    if (isDelete) {
      this.alertaModalService.confirmacion(
        this.alertaText['sic-comp-desleal-alertas']['subtitulo-eliminar'],
        this.alertaText['sic-comp-desleal-alertas'][
        'titulo-eliminar-demandado'
        ],
        removeDemandado,
        () => { }
      );
    } else {
      removeDemandado();
    }
  }

  /* �?Obtener un demandante como FormGroup */
  getDemandanteFormGroup(index: number): FormGroup {
    return this.DemandanteArray.at(index) as FormGroup;
  }

  /* �?Obtener un demandante como FormGroup */
  getDemandadoFormGroup(index: number): FormGroup {
    return this.DemandadoArray.at(index) as FormGroup;
  }

  /* 📌 Metodos para validación cambios en formularios */
  onChangeClaseSolicitud(formGroup: FormGroup) {
    this.formGroupClaseSolicitud = formGroup;
    if (formGroup?.invalid) {
      this.tipoClaseSolicitudValida = false;
    } else {
      this.tipoClaseSolicitudValida = true;
    }
  }

  onChangeDemandante(
    $event: { controlName?: string; controlValue: unknown; form: FormGroup },
    indice: number
  ) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: string = formGroup?.get('numeroOfDocument')?.value;
    if (
      $event.controlName == 'numeroOfDocument' ||
      $event.controlName == 'typeOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        let isEmptyApoderado: boolean = this.searchInApoderado(
          idTipoDocumento,
          identificacion
        );
        let isEmptyDemandado: boolean = this.searchInDemandados(
          idTipoDocumento,
          identificacion
        );
        let isEmptyDemandantes: boolean = this.searchInDemandantes(
          idTipoDocumento,
          identificacion
        );
        if (isEmptyApoderado && isEmptyDemandado && isEmptyDemandantes) {
          this.existePersonaDemandante = false;
          // this.validarUsuario(
          //   idTipoDocumento,
          //   identificacion,
          //   formGroup,
          //   'demandante',
          //   indice
          // );
        } else if (isEmptyDemandantes == false) {
          if (this.demandantes[indice] != undefined) {
            if (this.demandantes[indice].idTipoIdentificacion == idTipoDocumento &&
              this.demandantes[indice].identificacion == identificacion
            ) {
              this.existePersonaDemandante = false;
            } else {
              this.existePersonaDemandante = true;
              this.alertaModalService.advertencia(
                this.alertaText['tipo-numero-documento-existe-demandante']
              );
            }
          } else {
            this.existePersonaDemandante = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          }
        } else if (isEmptyDemandado == false) {
          this.existePersonaDemandante = true;
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandado']
          );
        } else if (isEmptyApoderado == false) {
          this.existePersonaDemandante = true;
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-apoderado']
          );
        }
      }
    }
    if ($event.controlName == 'tipoPersonaDemandante') {
      if (
        formGroup?.get('tipoPersonaDemandante')?.value ===
        Constants.TIPO_PERSONA.NATURAL
      ) {
        // Agregar validaciones para persona natural
        this.agregarValidacionesDemandanteNatural(formGroup);

        // Remover validaciones de otros campos que no aplican a persona natural
        this.removerValidacionesDemandanteJuridico(formGroup);
        this.showObligation('naturalDemandante', indice, 0);
      } else {
        // Agregar validaciones para otros tipos de personas
        this.agregarValidacionesDemandanteJuridico(formGroup);

        // Remover validaciones de persona natural si no es el tipo natural
        this.removerValidacionesDemandanteNatural(formGroup);
        this.showObligation('juridicoDemandante', indice, 0);
      }
    }

    const numeroDocumentoDemandante = this.formDemandante[indice].find(
      field => field.name == 'numeroOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numeroOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento === 5 ||
          idTipoDocumento === 2
        ) {
          if (numeroDocumentoDemandante != undefined) {
            formGroup
              .get('numeroOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandante.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandante.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandante.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandante != undefined) {
            formGroup
              .get('numeroOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(8),
                Validators.minLength(4),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandante.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandante.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandante.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else if (idTipoDocumento == 3) {
          if (numeroDocumentoDemandante != undefined) {
            formGroup
              .get('numeroOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandante.errorMessages!['maxlength'] =
              this.comunText['nit-maxlength'];
            numeroDocumentoDemandante.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }

        formGroup?.get('numeroOfDocument')?.updateValueAndValidity();
      }
    }
    const idTipoDocumentoRl: number = +formGroup?.get('typeOfDocumentRl')?.value;
    const numeroDocumentoDemandanteRl = this.formDemandante[indice].find(
      field => field.name == 'numeroOfDocumentRl'
    );
    if (
      $event.controlName == 'typeOfDocumentRl' ||
      $event.controlName == 'numeroOfDocumentRl'
    ) {
      if (idTipoDocumentoRl !== null && identificacion !== null) {
        if (
          idTipoDocumentoRl == 1 ||
          idTipoDocumentoRl === 5 ||
          idTipoDocumentoRl === 2
        ) {
          if (numeroDocumentoDemandanteRl != undefined) {
            formGroup
              .get('numeroOfDocumentRl')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandanteRl.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandanteRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandanteRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumentoRl == 4) {
          if (numeroDocumentoDemandanteRl != undefined) {
            formGroup
              .get('numeroOfDocumentRl')
              ?.setValidators([Validators.required, Validators.maxLength(8)]);
            numeroDocumentoDemandanteRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandanteRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }

        formGroup?.get('numeroOfDocumentRl')?.updateValueAndValidity();
      }
    }

    if ($event.controlName == 'country' || $event.controlName == 'countryRl') {
      const idPais = formGroup?.get('country')?.value;
      const idColombia = this.paises.find(
        item => item.Codigo === Constants.CODIGO_COLOMBIA
      )?.Id;
      if (idPais === idColombia) {
        formGroup?.controls['otroDepartamentoDemandante']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandante']?.removeValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandante')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandante')?.updateValueAndValidity();
      } else if (idPais !== null) {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandante.push(
            formGroup?.controls['country'].value
          );
          if (this.auxIdCountryDemandante.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandante[
              this.auxIdCountryDemandante.length - 2
              ];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandante'].setValue('');
          formGroup?.controls['otroMunicipioDemandante'].setValue('');
        }
        formGroup?.controls['otroDepartamentoDemandante']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandante']?.addValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandante')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandante')?.updateValueAndValidity();
        this.formDemandante[indice].forEach((field: FormField) => {
          if (
            ['otroMunicipioDemandante', 'otroDepartamentoDemandante'].includes(
              field.name
            )
          ) {
            field.required = true;
          }
        });
      }
      if (formGroup?.get('tipoPersonaDemandante')?.value == 2) {
        const idPaisRl = formGroup?.get('countryRl')?.value;

        if (idPaisRl === idColombia) {
          formGroup?.controls['otroDepartamentoDemandanteRl']?.removeValidators(
            Validators.required
          );
          formGroup?.controls['otroMunicipioDemandanteRl']?.removeValidators(
            Validators.required
          );
          formGroup
            .get('otroDepartamentoDemandanteRl')
            ?.updateValueAndValidity();
          formGroup?.get('otroMunicipioDemandanteRl')?.updateValueAndValidity();
        } else if (idPais !== null) {
          let clearInputs: boolean = false;
          if (formGroup?.controls['countryRl'].value) {
            this.auxIdCountryRlDemandante.push(
              formGroup?.controls['countryRl'].value
            );
            if (this.auxIdCountryRlDemandante.length > 1) {
              clearInputs =
                formGroup?.controls['countryRl'].value !=
                this.auxIdCountryRlDemandante[
                this.auxIdCountryRlDemandante.length - 2
                ];
            }
          }
          if (clearInputs) {
            formGroup?.controls['otroDepartamentoDemandanteRl'].setValue('');
            formGroup?.controls['otroMunicipioDemandanteRl'].setValue('');
          }
          formGroup?.controls['otroDepartamentoDemandanteRl']?.addValidators(
            Validators.required
          );
          formGroup?.controls['otroMunicipioDemandanteRl']?.addValidators(
            Validators.required
          );
          formGroup
            .get('otroDepartamentoDemandanteRl')
            ?.updateValueAndValidity();
          formGroup?.get('otroMunicipioDemandanteRl')?.updateValueAndValidity();
        }
      }
    }
    // this.mostrarCamposRequeridos(formGroup)
  }

  agregarValidacionesDemandanteNatural(formGroup: FormGroup) {
    formGroup
      ?.get('primerNombre')
      ?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
    formGroup
      ?.get('primerApellido')
      ?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
    const idPais = formGroup?.get('country')?.value;
    const idColombia = this.paises.find(
      item => item.Codigo === Constants.CODIGO_COLOMBIA
    )?.Id;
    if (idPais === idColombia) {
      formGroup?.controls['otroDepartamentoDemandante']?.removeValidators(
        Validators.required
      );
      formGroup?.controls['otroMunicipioDemandante']?.removeValidators(
        Validators.required
      );
      formGroup?.get('otroDepartamentoDemandante')?.updateValueAndValidity();
      formGroup?.get('otroMunicipioDemandante')?.updateValueAndValidity();
    } else if (idPais !== null) {
      formGroup?.controls['otroDepartamentoDemandante']?.addValidators(
        Validators.required
      );
      formGroup?.controls['otroMunicipioDemandante']?.addValidators(
        Validators.required
      );
      formGroup?.get('otroDepartamentoDemandante')?.updateValueAndValidity();
      formGroup?.get('otroMunicipioDemandante')?.updateValueAndValidity();
    }
    // Actualizar la validez de los campos
    ['primerNombre', 'primerApellido'].forEach(field => {
      formGroup?.get(field)?.updateValueAndValidity();
    });
  }

  // Método para remover las validaciones de los campos
  removerValidacionesDemandanteNatural(formGroup: FormGroup) {
    formGroup?.get('primerNombre')?.clearValidators();
    formGroup?.get('primerApellido')?.clearValidators();

    // Actualizar la validez de los campos
    ['primerNombre', 'primerApellido'].forEach(field => {
      formGroup?.get(field)?.updateValueAndValidity();
    });
  }

  // Método para agregar las validaciones a los campos persona juridica
  agregarValidacionesDemandanteJuridico(formGroup: FormGroup) {
    formGroup
      .get('razonSocial')
      ?.setValidators([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
        Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
      ]);
    formGroup?.get('typeOfDocumentRl')?.setValidators([Validators.required]);
    formGroup
      ?.get('numeroOfDocumentRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(20),
      ]);
    formGroup
      .get('firstNameRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
    formGroup
      .get('firstLastNameRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
    formGroup
      .get('addressRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(40),
        Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS),
      ]);
    formGroup?.get('countryRl')?.setValidators([Validators.required]);
    formGroup?.get('departamentRl')?.setValidators([Validators.required]);
    formGroup?.get('municipalityRl')?.setValidators([Validators.required]);
    formGroup
      .get('emailRl')
      ?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        Validators.maxLength(100),
      ]);

    // Actualizar la validez de los campos
    [
      'countryRl',
      'departamentRl',
      'municipalityRl',
      'razonSocial',
      'typeOfDocumentRl',
      'numeroOfDocumentRl',
      'firstNameRl',
      'firstLastNameRl',
      'addressRl',
      'emailRl',
    ].forEach(field => {
      formGroup?.get(field)?.updateValueAndValidity();
    });
  }

  // Método para remover las validaciones de los campos adicionales
  removerValidacionesDemandanteJuridico(formGroup: FormGroup) {
    [
      'razonSocial',
      'typeOfDocumentRl',
      'numeroOfDocumentRl',
      'firstNameRl',
      'firstLastNameRl',
      'addressRl',
      'countryRl',
      'departamentRl',
      'municipalityRl',
      'emailRl',
      'otroDepartamentoDemandanteRl',
      'otroMunicipioDemandanteRl'
    ].forEach(field => {
      formGroup?.get(field)?.clearValidators();
      formGroup?.get(field)?.setValue(null);
      formGroup?.get(field)?.updateValueAndValidity();
    });
  }

  onChangeTipoDemandante(formGroup: FormGroup, indice: number) {
    this.tipoPersonaDemandante = +formGroup?.get('tipoPersonaDemandante')?.value;
    if (formGroup?.get('tipoPersonaDemandante')?.value == 2) {
      this.formGroupDemandanteJuridico = formGroup;
      this.formDemandante[indice].forEach((field: FormField) => {
        if (field.name == 'numeroOfDocument') {
          field.label = this.comunText['nit'];
        }
      });
      // Agregar validaciones para otros tipos de personas
      this.actualizarValidacionesDemandanteJ(formGroup);

      // Remover validaciones de persona natural si no es el tipo natural
      this.removerValidacionesDemandanteNatural(formGroup);
    } else {
      this.formGroupDemandanteNatural = formGroup;
      this.formDemandante[indice].forEach((field: FormField) => {
        if (field.name == 'numeroOfDocument') {
          field.label = this.comunText['numero-documento'];
        }
      });
      // Agregar validaciones para persona natural
      this.agregarValidacionesDemandanteNatural(formGroup);

      // Remover validaciones de otros campos que no aplican a persona natural
      this.removerValidacionesDemandanteJuridico(formGroup);
    }
    if (formGroup?.invalid) {
      if (formGroup?.get('tipoPersonaDemandante')?.value == 2) {
        this.personaDemandanteJuridicoValida = false;
      } else {
        this.personaDemandanteNaturalValida = false;
      }
    } else {
      if (formGroup?.get('tipoPersonaDemandante')?.value == 2) {
        this.personaDemandanteJuridicoValida = true;
      } else {
        this.personaDemandanteNaturalValida = true;
      }
    }
    // this.mostrarCamposRequeridos(formGroup);
  }


  validacionTipoPersonaDemandante(): boolean {
    if (this.existePersonaDemandante) {
      return false;
    } else {
      if (this.tipoPersonaDemandante == Constants.TIPO_PERSONA.NATURAL) {
        return this.personaDemandanteNaturalValida;
      } else {
        return this.personaDemandanteJuridicoValida;
      }
    }

  }

  actualizarValidacionesDemandanteJ(formGroup: FormGroup) {
    formGroup
      .get('razonSocial')
      ?.setValidators([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
        Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
      ]);
    formGroup?.get('typeOfDocumentRl')?.setValidators([Validators.required]);
    formGroup
      ?.get('numeroOfDocumentRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(20),
      ]);
    formGroup
      .get('firstNameRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
    formGroup
      .get('firstLastNameRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
    formGroup
      .get('addressRl')
      ?.setValidators([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(40),
        Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS),
      ]);
    formGroup
      .get('emailRl')
      ?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        Validators.maxLength(100),
      ]);

    // Actualizar la validez de los campos
    [
      'razonSocial',
      'typeOfDocumentRl',
      'numeroOfDocumentRl',
      'firstNameRl',
      'firstLastNameRl',
      'addressRl',
      'emailRl',
    ].forEach(field => {
      formGroup?.get(field)?.updateValueAndValidity();
    });
  }

  onFormApoderado(formGroup: FormGroup) {
    this.onApoderado = false;
    this.formGroupApoderado = formGroup;
    if (formGroup?.get('country')?.value != 1) {
      formGroup?.get('departament')?.clearValidators();
      // formGroup.get('departament')?.updateValueAndValidity()
      formGroup?.get('municipality')?.clearValidators();
      formGroup?.get('municipality')?.updateValueAndValidity();
    } else {
      formGroup?.get('departament')?.setValidators(Validators.required);
      // formGroup.get('departament')?.updateValueAndValidity()
    }
    if (formGroup?.invalid) {
      this.apoderadoValida = false;
    } else {
      if (this.existePersonaApoderada) {
        this.apoderadoValida = false;
      } else {
        this.apoderadoValida = true;

      }
    }
  }

  onChangeApoderado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    if (
      $event.controlName == 'numberOfDocument' ||
      $event.controlName == 'typeOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        let isEmptyDemandante: boolean = this.searchInDemandantes(
          idTipoDocumento,
          identificacion
        );
        let isEmptyDemandado: boolean = this.searchInDemandados(
          idTipoDocumento,
          identificacion
        );
        if (isEmptyDemandado && isEmptyDemandante) {
          this.existePersonaApoderada = false;
          this.isApoderadoValido = true;
          // this.validarUsuario(
          //   idTipoDocumento,
          //   identificacion,
          //   formGroup,
          //   'apoderado',
          //   0
          // );
        } else if (isEmptyDemandante == false) {
          this.existePersonaApoderada = true;
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandante']
          );
        } else if (isEmptyDemandado == false) {
          this.existePersonaApoderada = true;
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandado']
          );
        } else {
          this.existePersonaApoderada = true;
          // this.formApoderado = this.formApoderado.map((field: FormField) => {
          //   if (field.type == 'select') {
          //     field.value = undefined;
          //   } else {
          //     field.value = '';
          //   }
          //   return field;
          // });
          this.isApoderadoValido = false;
        }
      }
      if (this.existePersonaApoderada) {
        formGroup?.get('numberOfDocument')?.setValue('');
      }
    }
    const numeroDocumentoApoderado = this.formApoderado.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento === 5 ||
          idTipoDocumento === 2
        ) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(8),
                Validators.minLength(4),

                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }
        formGroup?.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    this.formGroupApoderado = formGroup;
    if (
      $event.controlName == 'country'
    ) {
      this.validarFormApoderado(
        formGroup
      );
    }
    if (formGroup?.get('country')?.value == 1) {
      formGroup?.controls['otroDepartamentoApoderado']?.removeValidators(
        Validators.required
      );
      formGroup?.controls['otroMunicipioApoderado']?.removeValidators(
        Validators.required
      );
      formGroup?.get('otroDepartamentoApoderado')?.updateValueAndValidity();
      formGroup?.get('otroMunicipioApoderado')?.updateValueAndValidity();
    }
    if (formGroup?.invalid) {
      this.apoderadoValida = false;
    } else {
      this.apoderadoValida = true;
    }
    // this.mostrarCamposRequeridos(formGroup)
    if (this.existePersonaApoderada) {
      this.apoderadoValida = false;
    }
  }

  validarFormApoderado(form: FormGroup) {
    this.formApoderado.forEach((field: FormField) => {
      if (
        [
          'primerNombre',
          'primerApellido',
          'typeOfDocument',
          'numberOfDocument',
          'address',
          'professionalCard',
          'email',
          'country',
          'departament',
          'municipality',
        ].includes(field.name)
      ) {
        field.required = true;
      }
    });
    const idPais = form.get('country')?.value;
    const idColombia = this.paises.find(
      item => item.Codigo === Constants.CODIGO_COLOMBIA
    )?.Id;
    if (idPais === idColombia) {
      form?.controls['otroDepartamentoApoderado']?.removeValidators(
        Validators.required
      );
      form?.controls['otroMunicipioApoderado']?.removeValidators(
        Validators.required
      );
      form.get('otroDepartamentoApoderado')?.updateValueAndValidity();
      form.get('otroMunicipioApoderado')?.updateValueAndValidity();
    } else {
      let clearInputs: boolean = false;
      if (form?.controls['country'].value) {
        this.auxIdCountryApoderado.push(form?.controls['country'].value);
        if (this.auxIdCountryApoderado.length > 1) {
          clearInputs =
            form?.controls['country'].value !=
            this.auxIdCountryApoderado[this.auxIdCountryApoderado.length - 2];
        }
      }
      if (clearInputs) {
        form?.controls['otroDepartamentoApoderado'].setValue('');
        form?.controls['otroMunicipioApoderado'].setValue('');
      }
      form?.controls['otroDepartamentoApoderado']?.addValidators(
        Validators.required
      );
      form?.controls['otroMunicipioApoderado']?.addValidators(
        Validators.required
      );
      form.get('otroDepartamentoApoderado')?.updateValueAndValidity();
      form.get('otroMunicipioApoderado')?.updateValueAndValidity();
      this.formApoderado.forEach((field: FormField) => {
        if (
          ['otroMunicipioApoderado', 'otroDepartamentoApoderado'].includes(
            field.name
          )
        ) {
          field.required = true;
        }
      });
    }
    this.setValidacionesFormApoderado(form);
  }

  setValidacionesFormApoderado(formGroup: FormGroup) {
    this.addValidacionesFormApoderado(
      formGroup,
      ['primerNombre', 'primerApellido'],
      [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]
    );
    this.addValidacionesFormApoderado(
      formGroup,
      ['typeOfDocument'],
      [Validators.required]
    );
    this.addValidacionesFormApoderado(
      formGroup,
      ['numberOfDocument'],
      [Validators.required, Validators.minLength(4)]
    );
    this.addValidacionesFormApoderado(
      formGroup,
      ['address'],
      [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(40),
        Validators.pattern(Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS),
      ]
    );
    if (formGroup.controls['country'].value === 1) {
      this.addValidacionesFormApoderado(
        formGroup,
        ['country', 'departament', 'municipality'],
        [Validators.required]
      );
      this.limpiarValidacionesApoderado(formGroup, [
        'otroDepartamentoApoderado',
        'otroMunicipioApoderado',
      ]);
    } else {
      this.limpiarValidacionesApoderado(formGroup, [
        'departament',
        'municipality',
      ]);
    }
    this.addValidacionesFormApoderado(
      formGroup,
      ['professionalCard'],
      [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(12),
        Validators.pattern(Constants.REGEX_TELEFONO),
      ]
    );
    this.addValidacionesFormApoderado(
      formGroup,
      ['email'],
      [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
      ]
    );
    // this.mostrarCamposRequeridos(formGroup);
  }

  limpiarValidacionesApoderado(formGroup: FormGroup, fields: string[]) {
    fields.forEach(field => {
      const control = formGroup?.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  addValidacionesFormApoderado(
    formGroup: FormGroup,
    fields: string[],
    validators: any[]
  ) {
    fields.forEach(field => {
      const control = formGroup?.get(field);
      if (control) {
        control.setValidators(validators);
        control.updateValueAndValidity();
      }
    });
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: string
  ): boolean {
    let isEmpty: boolean = true;
    let i: number = 0;
    while (i < this.demandantes.length) {
      const elemento = this.demandantes[i];
      if (elemento.idTipoIdentificacion === idTipoDocumento) {
        if (elemento.identificacion == identificacion) {
          isEmpty = false;
          break;
        } else {
          isEmpty = true;
        }
      }
      i++;
    }
    return isEmpty;
  }

  searchInDemandados(idTipoDocumento: number, identificacion: string): boolean {
    let isEmpty: boolean = true;
    let i: number = 0;
    while (i < this.demandados.length) {
      const elemento = this.demandados[i];
      if (elemento.idTipoIdentificacion === idTipoDocumento) {
        if (elemento.identificacion === identificacion) {
          isEmpty = false;
          break;
        } else {
          isEmpty = true;
        }
      }
      i++;
    }
    return isEmpty;
  }

  searchInApoderado(idTipoDocumento: number, identificacion: string): boolean {
    let isEmpty: boolean = true;
    let idTipoDocumentoApoderado: number = 0;
    let identificacionApoderado: string = '';
    let contador: number = 0;
    if (this.formGroupApoderado.valid) {
      idTipoDocumentoApoderado =
        +this.formGroupApoderado.get('typeOfDocument')?.value;
      identificacionApoderado =
        this.formGroupApoderado.get('numberOfDocument')?.value;
      if (
        idTipoDocumentoApoderado === idTipoDocumento &&
        identificacionApoderado == identificacion
      ) {
        contador++;
        isEmpty = false;
      }
    } else {
      if (this.apoderadoPrecarga != undefined) {
        idTipoDocumentoApoderado = this.apoderadoPrecarga.idTipoIdentificacion;
        identificacionApoderado = this.apoderadoPrecarga.identificacion;
        identificacion = identificacion.toUpperCase();
        if (
          idTipoDocumentoApoderado == idTipoDocumento &&
          identificacionApoderado == identificacion
        ) {
          contador++;
          isEmpty = false;
        }
      }
    }
    if (contador > 0) {
      isEmpty = false;
    }
    return isEmpty;
  }

  // Función para agregar validaciones a un conjunto de campos
  agregarValidacionesDemandado(
    formGroup: FormGroup,
    fields: string[],
    validators: any[]
  ) {
    fields.forEach(field => {
      const control = formGroup?.get(field);
      if (control) {
        control.setValidators(validators);
        control.updateValueAndValidity();
      }
    });
  }

  // Función para limpiar validaciones de un conjunto de campos
  limpiarValidacionesDemandado(formGroup: FormGroup, fields: string[]) {
    fields.forEach(field => {
      const control = formGroup?.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  // Función para agregar validaciones específicas a los campos de persona natural
  agregarValidacionesPersonaNaturalDemandado(formGroup: FormGroup) {
    this.agregarValidacionesDemandado(
      formGroup,
      ['primerNombre', 'primerApellido'],
      [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]
    );
    // Si conoce domicilio
    if (formGroup.controls['direccionDomicilio'].value == 1) {
      this.agregarValidacionesDemandado(
        formGroup,
        ['direccionPersona'],
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ]
      );

      ['country', 'departament', 'municipality'].forEach(field => {
        formGroup?.get(field)?.setValidators([Validators.required]);
        // formGroup.get(field)?.updateValueAndValidity();
      });
    } else {
      this.limpiarValidacionesDemandado(formGroup, [
        'country',
        'departament',
        'municipality',
        'direccionPersona',
        'otroDepartamentoDemandado',
        'otroMunicipioDemandado',
      ]);
    }
  }

  // Función para agregar validaciones específicas a los campos de persona jurídica
  agregarValidacionesPersonaJuridicaDemandado(formGroup: FormGroup) {
    // Si conoce domicilio
    if (formGroup?.controls['direccionDomicilio'].value == 1) {
      this.agregarValidacionesDemandado(
        formGroup,
        ['razonSocial'],
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['direccionPersona'],
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['firstNameRl', 'firstLastNameRl'],
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]
      );

      this.agregarValidacionesDemandado(
        formGroup,
        ['addressRl'],
        [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['emailRl'],
        [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ]
      );
      ['country', 'departament', 'municipality'].forEach(field => {
        formGroup?.get(field)?.setValidators([Validators.required]);
        // formGroup.get(field)?.updateValueAndValidity();
      });
    } else {
      this.agregarValidacionesDemandado(
        formGroup,
        ['razonSocial'],
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['emailRl'],
        [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['firstNameRl', 'firstLastNameRl'],
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]
      );
      this.limpiarValidacionesDemandado(formGroup, [
        'country',
        'departament',
        'municipality',
        'direccionPersona',
        'addressRl',
        'countryRl',
        'departamentRl',
        'municipalityRl',
        'otroDepartamentoDemandadoRl',
        'otroMunicipioDemandadoRl',
      ]);
    }
  }

  mostrarCamposRequeridos(formGroup: FormGroup) {
    const camposRequeridos = Object.keys(formGroup.controls).filter(
      controlName =>
        formGroup?.get(controlName)?.hasValidator(Validators.required)
    );
  }

  // Método principal onChangePersonaDemandado
  onChangePersonaDemandado(
    $event: { controlName?: string; controlValue: unknown; form: FormGroup },
    indice: number
  ) {
    const formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: string = formGroup?.get('numeroOfDocument')?.value;
    if (
      $event.controlName == 'numeroOfDocument' ||
      $event.controlName == 'typeOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== undefined) {
        let isEmptyApoderado: boolean = this.searchInApoderado(
          idTipoDocumento,
          identificacion
        );
        let isEmptyDemandante: boolean = this.searchInDemandantes(
          idTipoDocumento,
          identificacion
        );
        let isEmptyDemandado: boolean = this.searchInDemandados(
          idTipoDocumento,
          identificacion
        );
        if (isEmptyApoderado && isEmptyDemandante && isEmptyDemandado) {
          this.existePersonaDemandado = false;
          // this.validarUsuario(
          //   idTipoDocumento,
          //   identificacion,
          //   formGroup,
          //   'demandado',
          //   indice
          // );
        } else if (isEmptyDemandante == false) {
          this.existePersonaDemandado = true;
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-demandante']
          );
        } else if (isEmptyDemandado == false) {
          if (this.demandados[indice] != undefined) {
            if (this.demandados[indice].idTipoIdentificacion == idTipoDocumento &&
              this.demandados[indice].identificacion == identificacion
            ) {
              this.existePersonaDemandado = false;
            } else {
              this.existePersonaDemandado = true;
              this.alertaModalService.advertencia(
                this.alertaText['tipo-numero-documento-existe-demandado']
              );
            }
          } else {
            this.existePersonaDemandado = true;
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandado']
            );
          }
        } else if (isEmptyApoderado == false) {
          this.existePersonaDemandado = true;
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-apoderado']
          );
        }
      }
    }
    const numeroDocumentoDemandado = this.formDemandado[indice].find(
      field => field.name == 'numeroOfDocument'
    );
    // if (
    //   $event.controlName == 'tipoPersonaDemandado' ||
    //   $event.controlName == 'direccionDomicilio'
    // ) {
    if (
      formGroup?.get('tipoPersonaDemandado')?.value ===
      Constants.TIPO_PERSONA.NATURAL
    ) {
      this.agregarValidacionesPersonaNaturalDemandado(formGroup);
      this.limpiarValidacionesDemandado(formGroup, [
        'razonSocial',
        'typeOfDocumentRl',
        'numeroOfDocumentRl',
        'firstNameRl',
        'firstLastNameRl',
        'countryRl',
        'departamentRl',
        'municipalityRl',
        'otroDepartamentoDemandadoRl',
        'otroMunicipioDemandadoRl',
      ]);
      this.showObligation('naturalDemandando', indice, 0);
    } else {
      this.agregarValidacionesPersonaJuridicaDemandado(formGroup);
      this.limpiarValidacionesDemandado(formGroup, [
        'primerNombre',
        'primerApellido',
      ]);
      this.showObligation(
        'juridicoDemandado',
        indice,
        formGroup?.get('direccionDomicilio')?.value
      );
    }
    // }
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numeroOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 5 ||
          idTipoDocumento == 2
        ) {
          if (numeroDocumentoDemandado != undefined) {
            formGroup
              .get('numeroOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandado != undefined) {
            formGroup
              .get('numeroOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else if (idTipoDocumento == 3) {
          if (numeroDocumentoDemandado != undefined) {
            formGroup
              .get('numeroOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandado.errorMessages!['maxlength'] =
              'El número de documento debe contener máximo 9 números';
            numeroDocumentoDemandado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }
        formGroup?.get('numeroOfDocument')?.updateValueAndValidity();
      }
    }
    let idTipoDocumentoRl: number = +formGroup?.get('typeOfDocumentRl')?.value;
    const numeroDocumentoDemandadoRl = this.formDemandado[indice].find(
      field => field.name == 'numeroOfDocumentRl'
    );
    if (
      $event.controlName == 'typeOfDocumentRl' ||
      $event.controlName == 'numeroOfDocumentRl'
    ) {
      if (idTipoDocumentoRl !== null && identificacion !== null) {
        if (idTipoDocumentoRl == 1 || idTipoDocumentoRl == 2) {
          if (numeroDocumentoDemandadoRl != undefined) {
            formGroup
              .get('numeroOfDocumentRl')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandadoRl.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandadoRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandadoRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumentoRl == 4) {
          if (numeroDocumentoDemandadoRl != undefined) {
            formGroup
              .get('numeroOfDocumentRl')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandadoRl.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandadoRl.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }

        formGroup?.get('numeroOfDocumentRl')?.updateValueAndValidity();
      }
    }
    // this.mostrarCamposRequeridos(formGroup);
  }

  onChangeDemandado(formGroup: FormGroup, indice: number) {
    this.formGroupDemandado = formGroup;
    this.tipoPersonaDemandado = +formGroup?.get('tipoPersonaDemandado')?.value;
    formGroup?.get('direccionDomicilio')?.setValidators([Validators.required]);
    formGroup?.get('direccionDomicilio')?.updateValueAndValidity();
    if (formGroup?.get('tipoPersonaDemandado')?.value == 2) {
      this.formDemandado[indice].forEach((field: FormField) => {
        if (field.name == 'numeroOfDocument') {
          field.label = this.comunText['nit'];
        }
      });
      this.validarDocumentoJuridica(formGroup);
      formGroup?.get('primerNombre')?.clearValidators();
      formGroup?.get('primerNombre')?.updateValueAndValidity();
      formGroup?.get('primerApellido')?.clearValidators();
      formGroup?.get('primerApellido')?.updateValueAndValidity();
      formGroup
        ?.get('razonSocial')
        ?.setValidators([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ]);
      formGroup?.get('razonSocial')?.updateValueAndValidity();
      formGroup
        ?.get('firstNameRl')
        ?.setValidators([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]);
      formGroup?.get('firstNameRl')?.updateValueAndValidity();
      formGroup
        ?.get('firstLastNameRl')
        ?.setValidators([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]);
      formGroup?.get('firstLastNameRl')?.updateValueAndValidity();

      formGroup
        ?.get('emailRl')
        ?.setValidators([
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ]);
      formGroup?.get('emailRl')?.updateValueAndValidity();
      let direccionDomicilio = formGroup?.get('direccionDomicilio')?.value;
      if (formGroup?.get('direccionDomicilio')?.value == 1) {
        formGroup
          ?.get('direccionPersona')
          ?.setValidators([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(40),
            Validators.pattern(
              Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
            ),
          ]);
        formGroup?.get('direccionPersona')?.updateValueAndValidity();
        formGroup
          ?.get('addressRl')
          ?.setValidators([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(40),
            Validators.pattern(
              Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
            ),
          ]);
        formGroup?.get('addressRl')?.updateValueAndValidity();
        formGroup?.get('countryRl')?.setValidators([Validators.required]);

        formGroup?.get('departamentRl')?.setValidators([Validators.required]);

        formGroup?.get('municipalityRl')?.setValidators([Validators.required]);
      } else {
        formGroup?.get('direccionPersona')?.clearValidators();
        formGroup?.get('direccionPersona')?.updateValueAndValidity();
        formGroup?.get('addressRl')?.clearValidators();
        formGroup?.get('addressRl')?.updateValueAndValidity();
        formGroup?.get('countryRl')?.clearValidators();
        formGroup?.get('departamentRl')?.clearValidators();
        formGroup?.get('municipalityRl')?.clearValidators();
        formGroup?.get('otroDepartamentoDemandadoRl')?.clearValidators();
        formGroup?.get('otroMunicipioDemandadoRl')?.clearValidators();
        setTimeout(() => {
          formGroup?.get('country')?.setValue(null);
          formGroup?.get('countryRl')?.setValue(null);
        }, 500);
      }
      const idPais = formGroup?.get('countryRl')?.value;
      const idColombia = this.paises.find(
        item => item.Codigo === Constants.CODIGO_COLOMBIA
      )?.Id;
      if (idPais === idColombia) {
        formGroup?.controls['otroDepartamentoDemandadoRl']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandadoRl']?.removeValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandadoRl')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandadoRl')?.updateValueAndValidity();
      } else if (idPais !== null) {
        let clearInputs: boolean = false;
        if (formGroup?.controls['countryRl'].value) {
          this.auxIdCountryRlDemandado.push(
            formGroup?.controls['countryRl'].value
          );
          if (this.auxIdCountryRlDemandado.length > 1) {
            clearInputs =
              formGroup?.controls['countryRl'].value !=
              this.auxIdCountryRlDemandado[
              this.auxIdCountryRlDemandado.length - 2
              ];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandadoRl'].setValue('');
          formGroup?.controls['otroMunicipioDemandadoRl'].setValue('');
        }
        formGroup?.controls['otroDepartamentoDemandadoRl']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandadoRl']?.addValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandadoRl')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandadoRl')?.updateValueAndValidity();
        this.formDemandado[indice].forEach((field: FormField) => {
          if (
            [
              'otroMunicipioDemandadoRl',
              'otroDepartamentoDemandadoRl',
            ].includes(field.name)
          ) {
            field.required = true;
          }
        });
      }
      this.showObligation('juridicoDemandado', indice, direccionDomicilio);
    } else {
      this.formDemandado[indice].forEach((field: FormField) => {
        if (field.name == 'numeroOfDocument') {
          field.label = this.comunText['numero-documento'];
        }
      });
      // this.validarDocumentoNatural(formGroup);
      formGroup
        ?.get('primerNombre')
        ?.setValidators([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]);
      formGroup?.get('primerNombre')?.updateValueAndValidity();
      formGroup
        ?.get('primerApellido')
        ?.setValidators([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]);
      formGroup?.get('primerApellido')?.updateValueAndValidity();
      if (formGroup?.get('direccionDomicilio')?.value == 1) {
        formGroup
          .get('direccionPersona')
          ?.setValidators([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(40),
            Validators.pattern(
              Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
            ),
          ]);
        formGroup?.get('direccionPersona')?.updateValueAndValidity();
        formGroup
          .get('correoElectronico')
          ?.setValidators([
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          ]);
        formGroup?.get('correoElectronico')?.updateValueAndValidity();
      } else {
        formGroup?.get('direccionPersona')?.clearValidators();
        formGroup?.get('direccionPersona')?.updateValueAndValidity();
        setTimeout(() => {
          formGroup?.get('country')?.setValue(null);
        }, 500);
      }
      this.showObligation('naturalDemandando', indice, 0);
    }
    if (formGroup?.get('direccionDomicilio')?.value == 1) {
      const idPais = formGroup?.get('country')?.value;
      const idColombia = this.paises.find(
        item => item.Codigo === Constants.CODIGO_COLOMBIA
      )?.Id;
      if (idPais === idColombia) {
        formGroup?.controls['otroDepartamentoDemandado']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandado']?.removeValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandado')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandado')?.updateValueAndValidity();
      } else if (idPais !== null) {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandado.push(formGroup?.controls['country'].value);
          if (this.auxIdCountryDemandado.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandado[this.auxIdCountryDemandado.length - 2];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandado'].setValue('');
          formGroup?.controls['otroMunicipioDemandado'].setValue('');
        }
        formGroup?.controls['otroDepartamentoDemandado']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandado']?.addValidators(
          Validators.required
        );
        formGroup?.get('otroDepartamentoDemandado')?.updateValueAndValidity();
        formGroup?.get('otroMunicipioDemandado')?.updateValueAndValidity();
        this.formDemandado[indice].forEach((field: FormField) => {
          if (
            ['otroMunicipioDemandado', 'otroDepartamentoDemandado'].includes(
              field.name
            )
          ) {
            field.required = true;
          }
        });
      }
    }
    if (formGroup?.invalid) {
      if (formGroup?.get('tipoPersonaDemandado')?.value == 2) {
        this.personaDemandadoJuridicoValida = false;
      } else {
        this.personaDemandadoNaturalValida = false;
      }
    } else {
      if (formGroup?.get('tipoPersonaDemandado')?.value == 2) {
        this.personaDemandadoJuridicoValida = true;
      } else {
        this.personaDemandadoNaturalValida = true;
      }
    }
    // this.mostrarCamposRequeridos(formGroup)
  }

  validarDocumentoNatural(formGroup: FormGroup) {
    formGroup?.get('typeOfDocument')?.setValidators([Validators.required]);
    if (
      formGroup?.get('typeOfDocument')?.value == 1 ||
      formGroup?.get('typeOfDocument')?.value == 2
    ) {
      formGroup
        ?.get('numeroOfDocument')
        ?.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern(/^\d+$/),
        ]);
    } else if (formGroup?.get('typeOfDocument')?.value == 4) {
      formGroup
        ?.get('numeroOfDocument')
        ?.setValidators([
          Validators.required,
          Validators.maxLength(8),
          Validators.pattern(
            Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
          ),
        ]);
    }
    formGroup?.get('typeOfDocument')?.updateValueAndValidity();
    formGroup?.get('numeroOfDocument')?.updateValueAndValidity();
  }

  validarDocumentoJuridica(formGroup: FormGroup) {
    formGroup?.get('typeOfDocumentRl')?.setValidators([Validators.required]);
    if (formGroup?.get('typeOfDocumentRl')?.value == 1) {
      formGroup
        ?.get('numeroOfDocumentRl')
        ?.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern(/^\d+$/),
        ]);
      formGroup?.get('numeroOfDocumentRl')?.updateValueAndValidity();
    } else if (formGroup?.get('typeOfDocumentRl')?.value == 4) {
      formGroup
        ?.get('numeroOfDocumentRl')
        ?.setValidators([
          Validators.required,
          Validators.maxLength(8),
          Validators.pattern(
            Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
          ),
        ]);
      formGroup?.get('numeroOfDocumentRl')?.updateValueAndValidity();
    } else if (formGroup?.get('typeOfDocument')?.value == 3) {
      formGroup
        ?.get('numeroOfDocument')
        ?.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern(/^\d+$/),
        ]);
      formGroup?.get('numeroOfDocument')?.updateValueAndValidity();
    }
    formGroup?.get('typeOfDocumentRl')?.updateValueAndValidity();
  }

  actualizarValidacionesDemandadoJ(formGroup: FormGroup) {
    // Si conoce domicilio
    if (formGroup.controls['direccionDomicilio'].value === 1) {
      this.agregarValidacionesDemandado(
        formGroup,
        ['razonSocial'],
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['direccionPersona'],
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['typeOfDocumentRl'],
        [Validators.required]);
      this.agregarValidacionesDemandado(
        formGroup,
        ['numeroOfDocumentRl'],
        [Validators.required,
        Validators.minLength(4),
        Validators.maxLength(20)]);
      this.agregarValidacionesDemandado(
        formGroup,
        ['firstNameRl', 'firstLastNameRl'],
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ]
      );
      // Validación específica para el email
      this.agregarValidacionesDemandado(
        formGroup,
        ['correoElectronico'],
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['addressRl'],
        [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ]
      );
      this.agregarValidacionesDemandado(
        formGroup,
        ['emailRl'],
        [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ]
      );
    } else {
      this.agregarValidacionesDemandado(
        formGroup,
        ['razonSocial'],
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ]
      );
      this.limpiarValidacionesDemandado(formGroup, [
        'correoElectronico',
        'direccionPersona',
        'typeOfDocumentRl',
        'numeroOfDocumentRl',
        'firstNameRl',
        'firstLastNameRl',
        'addressRl',
        'countryRl',
        'departamentRl',
        'municipalityRl',
        'emailRl',
        'otroDepartamentoDemandadoRl',
        'otroMunicipioDemandadoRl',
      ]);
    }
  }

  /* 📌 Metodos para validacion de netx steps y validacion final de todo el formulario*/

  validacionPaso1(): boolean {
    return this.tipoClaseSolicitudValida;
  }

  validacionPaso4(): boolean {
    return this.direccionDomicilioValida;
  }

  /**Seccion demandantes */
  guardarDemandanteArray(
    form: FormGroup,
    index: number,
    esProvisional: boolean
  ) {

    this.demandanteComponentes.forEach((comp: FormComponent) => {
      comp.marcarTodoComoTocado();
    });

    const valido = this.validacionTipoPersonaDemandante();

    if (!valido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    const esNatural: boolean =
      form.get('tipoPersonaDemandante')?.value ===
      Constants.TIPO_PERSONA.NATURAL;
    const demandante = this.crearDemandante(form, esNatural);

    if (esProvisional) {
      // Buscar si ya existe una persona con mismo tipo y número de documento
      const indiceExistente = this.demandantes.findIndex(
        (d) =>
          d.idTipoIdentificacion == demandante.idTipoIdentificacion &&
          d.identificacion == demandante.identificacion
      );
      if (this.existePersonaDemandante) {
        this.alertaModalService.error(
          this.alertaText['sic-comp-desleal-alertas']['error'],
          this.alertaText['sic-comp-desleal-alertas']['existe']
        );
      } else {
        if (indiceExistente !== -1) {
          // Ya existe → ACTUALIZAR
          const id = this.demandantes[indiceExistente].id ?? 0;
          demandante.id = id;
          this.demandantes[indiceExistente] = demandante;
          this.alertaModalService.exito(
            this.alertaText['sic-comp-desleal-alertas']['actualizado'],
            this.alertaText['sic-comp-desleal-alertas']['actualizado-exitoso']
          );
        } else {
          // No existe → AGREGAR NUEVO
          this.demandantes.push(demandante);
          this.alertaModalService.exito(
            this.alertaText['agregado'],
            this.alertaText['demandante-agregado']
          );
        }

        this.deshabilitarAddDemandante = false;
        this.submitForm(false, true);
        this.isSaveDemandante = this.validacionTipoPersonaDemandante();
      }
    } else {
      let id: number = 0;
      if (
        demandante.idTipoIdentificacion != 0 &&
        demandante.identificacion != undefined
      ) {
        if (this.existePersonaDemandante == false) {
          if (this.demandantes[index] != undefined) {
            id = this.demandantes[index].id!;
            demandante.id = id;
            this.demandantes[index] = demandante;
            this.deshabilitarAddDemandante = false;
            this.agregarDemandante(demandante, esNatural, false);
            this.alertaModalService.exito(
              this.alertaText['sic-comp-desleal-alertas']['actualizado'],
              this.alertaText['sic-comp-desleal-alertas']['actualizado-exitoso']
            );
            this.isSaveDemandante = this.validacionTipoPersonaDemandante();
          } else {
            if (this.existeDemandante(demandante)) {
              this.alertaModalService.error(
                this.alertaText['error'],
                this.alertaText['demandante-ya-agregado']
              );
            } else {
              this.deshabilitarAddDemandante = false;
              this.agregarDemandante(demandante, esNatural, false);
              this.alertaModalService.exito(
                this.alertaText['agregado'],
                this.alertaText['demandante-agregado']
              );
              this.isSaveDemandante = this.validacionTipoPersonaDemandante();
            }
          }
        } else {
          this.alertaModalService.error(
            this.alertaText['sic-comp-desleal-alertas']['error'],
            this.alertaText['sic-comp-desleal-alertas']['existe']
          );
        }
      } else {
        // this.alertaModalService.error(
        //   this.alertaText['error'],
        //   this.alertaText['sic-comp-desleal-alertas']['tipo-documento-invalido']
        // );
      }
    }
    this.auxIdCountryDemandante = [];
    this.auxIdCountryRlDemandante = [];

  }

  guardarDemandantePrecarga(form: PersonaDto, esNatural: boolean) {
    form.identificacion = form.numeroOfDocument?.toString();
    form.idTipoIdentificacion = form.typeOfDocument;

    // Elimina propiedades innecesarias
    delete form.numeroOfDocument;
    delete form.typeOfDocument;
    this.agregarDemandante(form, esNatural, false);
    this.deshabilitarAddDemandante = this.esValidoObligatoriosDemandante(form, esNatural);
  }

  esValidoObligatoriosDemandante(form: PersonaDto, esNatural: boolean): boolean {

    const formGroup = esNatural
      ? this.createDemandanteNaturalForm()
      : this.createDemandanteJuridicoForm();

    // Si el objeto tiene estructura tipoPersona, tomar esa rama
    const datos = (form as any).tipoPersona ? (form as any).tipoPersona : form;

    // Mapeo según tipo de persona
    const datosNormalizados = esNatural
      ? this.mapearNatural(datos)
      : this.mapearJuridica(datos);

    // Asignar al formGroup
    formGroup.patchValue(datosNormalizados);
    formGroup.markAllAsTouched();
    if (datosNormalizados?.country && datosNormalizados.country != Constants.DATO_COUNTRY_VALIDATE) {
      formGroup.get('country')?.clearValidators();
      formGroup.get('departament')?.clearValidators();
      formGroup.get('countryRl')?.clearValidators();
      formGroup.get('departamentRl')?.clearValidators();
      // Actualizamos los validadores para reflejar los cambios
      formGroup.get('country')?.updateValueAndValidity();
      formGroup.get('departament')?.updateValueAndValidity();
      formGroup.get('countryRl')?.updateValueAndValidity();
      formGroup.get('departamentRl')?.updateValueAndValidity();
    }
    if (formGroup.valid) {
      return false;
    } else {
      return true;
    }
  }

  /*Mapeo para persona natural */
  private mapearNatural(datos: any) {
    const form = this.formGroupDemandanteNatural
    return {
      idTipoPersona: datos.idTipoPersona || datos.tipoPersonaDemandante || '',
      typeOfDocument: datos.idTipoIdentificacion || datos.typeOfDocument || '',
      numberOfDocument: datos.identificacion || datos.numberOfDocument || '',
      primerNombre: datos.primerNombre || '',
      segundoNombre: datos.segundoNombre || '',
      primerApellido: datos.primerApellido || '',
      segundoApellido: datos.segundoApellido || '',
      direccionPersona: datos.direccionPersona?.[0]?.direccionNotificacion || [],
      country: form.get('country')?.value || datos.country || '',
      departament: form.get('departament')?.value || datos.departament || '',
      municipality: form.get('municipality')?.value || datos.municipality || '',
      correoElectronico: datos.correoElectronico || '',
      esApoderado: datos.esApoderado || false,
    };
  }

  /* Mapeo para persona jurídica */
  private mapearJuridica(datos: any) {
    const form = this.formGroupDemandanteJuridico
    const rl = datos.datosRepresentanteLegal || {};

    return {
      idTipoPersona: datos.idTipoPersona || datos.tipoPersonaDemandante || '',
      idTipoIdentificacion: datos.idTipoIdentificacion || '',
      numberOfDocumentNIT: datos.identificacion || '',
      razonSocial: datos.razonSocial || '',
      country: form.get('country')?.value || datos.country || '',
      departament: form.get('departament')?.value || datos.departament || '',
      municipality: form.get('municipality')?.value || datos.municipality || '',
      email: datos.correoElectronico || '',
      esApoderado: datos.esApoderado || false,

      // Datos del representante legal
      idTipoPersonaRL: 1 || '',
      typeOfDocumentRl: rl.idTipoIdentificacion || '',
      numberOfDocument: rl.identificacion || '',
      firstNameRl: rl.primerNombre || '',
      secondNameRl: rl.segundoNombre || '',
      firstLastNameRl: rl.primerApellido || '',
      secondLastNameRl: rl.segundoApellido || '',
      addressRl: rl.direccionPersona?.[0]?.direccionNotificacion || '',
      countryRl: form.get('countryRl')?.value || rl.country || '',
      departamentRl: form.get('departamentRl')?.value || rl.departament || '',
      municipalityRl: form.get('municipalityRl')?.value || rl.municipio?.id || rl.municipality || '',
      emailRl: rl.correoElectronico || '',
    };
  }

  crearDemandante(form: FormGroup, esNatural: boolean): PersonaDto {
    if (esNatural) {

      return {
        idTipoPersona: +form.get('tipoPersonaDemandante')?.value,
        idTipoIdentificacion: +form.get('typeOfDocument')?.value,
        identificacion: form.get('numeroOfDocument')?.value,
        municipio: { id: form.get('municipality')?.value },
        ciudadExtranjero: form.get('otroMunicipioDemandante')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandante')?.value,
        correoElectronico: form.get('correoElectronico')?.value,
        primerNombre: form.get('primerNombre')?.value,
        segundoNombre: form.get('segundoNombre')?.value,
        primerApellido: form.get('primerApellido')?.value,
        segundoApellido: form.get('segundoApellido')?.value,
        direccionPersona: [
          {
            direccionNotificacion: form.get('direccionPersona')?.value,
          },
        ],
        esApoderado: false,
      };
    } else {

      const representanteLegal: PersonaDto = {
        idTipoPersona: 1,
        idTipoIdentificacion: form.get('typeOfDocumentRl')?.value ?? undefined,
        identificacion: form.get('numeroOfDocumentRl')?.value,
        primerNombre: form.get('firstNameRl')?.value ?? undefined,
        segundoNombre: form.get('secondNameRl')?.value,
        primerApellido: form.get('firstLastNameRl')?.value ?? undefined,
        segundoApellido: form.get('secondLastNameRl')?.value,
        correoElectronico: form.get('emailRl')?.value,
        municipio: {
          id: form.get('municipalityRl')?.value,
        },
        ciudadExtranjero: form.get('otroMunicipioDemandanteRl')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandanteRl')?.value,
      };
      if (this.validarDireccion(form.get('addressRl')?.value)) {
        representanteLegal.direccionPersona = [
          {
            direccionNotificacion: form.get('addressRl')?.value,
          },
        ];
      }
      return {
        idTipoPersona: +form.get('tipoPersonaDemandante')?.value,
        idTipoIdentificacion: +form.get('typeOfDocument')?.value,
        identificacion: form.get('numeroOfDocument')?.value,
        razonSocial: form.get('razonSocial')?.value,
        municipio: { id: form.get('municipality')?.value },
        ciudadExtranjero: form.get('otroMunicipioDemandante')?.value,
        departamentoExtranjero: form.get('otroDepartamentoDemandante')?.value,
        correoElectronico: form.get('correoElectronico')?.value,
        direccionPersona: form.get('direccionPersona')?.value
          ? this.validarDireccion(form.get('direccionPersona')?.value)
            ? [
              {
                direccionNotificacion: form.get('direccionPersona')?.value,
              },
            ]
            : null
          : null,
        esApoderado: false,
        datosRepresentanteLegal: representanteLegal,
      };
    }
  }

  agregarDemandante(
    demandante: PersonaDto,
    esNatural: boolean,
    esPrecarge: boolean
  ): void {
    this.onDemandante = false;
    this.demandantes.push(demandante);
    this.agregarDemandanteArray(esNatural);
    this.demandantes.forEach(element => {
      this.removeDemandanteForm(this.DemandanteArray.length - 1, false, false);
    });

    this.tipoPersonaDemandante =
      this.demandantes[this.demandantes.length - 1].idTipoPersona!;
    if (esPrecarge) {
      this.submitForm(false, true);
    }
  }

  validarObligatoriosRl(valor: string | undefined): boolean {
    // Verifica que sea un string no vacío
    if (typeof valor === 'string' && valor.trim().length > 0) {
      return true;
    }
    // Si llega aquí, no cumple las condiciones
    return false;
  }

  agregarDemandanteArray(esNatural: boolean) {
    if (esNatural) {
      this.demandantes.forEach((demandante: PersonaDto) => {
        this.DemandanteArray.push(
          this.fb.group({
            idTipoPersona: new FormControl(demandante.idTipoPersona),
            idTipoIdentificacion: new FormControl(
              demandante.idTipoIdentificacion
            ),
            identificacion: new FormControl(demandante.identificacion),
            country: new FormControl(demandante.municipio),
            otroDepartamentoDemandante: new FormControl(
              demandante.departamentoExtranjero
            ),
            otroMunicipioDemandante: new FormControl(
              demandante.ciudadExtranjero
            ),
            correoElectronico: new FormControl(demandante.correoElectronico),
            firstName: new FormControl(demandante.primerNombre),
            secondName: new FormControl(demandante.segundoNombre),
            firstLastName: new FormControl(demandante.primerApellido),
            secondLastName: new FormControl(demandante.segundoApellido),
            addressNotificationJudicial: new FormControl(
              demandante.direccionPersona?.[0].direccionNotificacion
            ),
            esApoderado: new FormControl(false),
          })
        );
      });
    } else {
      this.demandantes.forEach((demandante: PersonaDto) => {
        this.DemandanteArray.push(
          this.fb.group({
            idTipoPersona: new FormControl(demandante.idTipoPersona),
            idTipoIdentificacion: new FormControl(
              demandante.idTipoIdentificacion
            ),
            numberOfDocumentNIT: new FormControl(demandante.razonSocial),
            razonSocial: new FormControl(demandante.razonSocial),
            municipality: new FormControl(demandante.municipio?.id),
            otroDepartamentoDemandante: new FormControl(
              demandante.departamentoExtranjero
            ),
            otroMunicipioDemandante: new FormControl(
              demandante.ciudadExtranjero
            ),
            email: new FormControl(demandante.correoElectronico),
            addressNotificationJudicial: new FormControl(
              demandante.direccionPersona?.[0].direccionNotificacion
            ),
            esApoderado: new FormControl(false),
            idTipoPersonaRL: new FormControl(
              demandante.datosRepresentanteLegal?.idTipoPersona
            ),
            typeOfDocumentRl: new FormControl(
              demandante.datosRepresentanteLegal?.idTipoIdentificacion
            ),
            numberOfDocument: new FormControl(
              demandante.datosRepresentanteLegal?.identificacion
            ),
            firstNameRl: new FormControl(
              demandante.datosRepresentanteLegal?.primerNombre
            ),
            secondNameRl: new FormControl(
              demandante.datosRepresentanteLegal?.segundoNombre
            ),
            firstLastNameRl: new FormControl(
              demandante.datosRepresentanteLegal?.primerApellido
            ),
            secondLastNameRl: new FormControl(
              demandante.datosRepresentanteLegal?.segundoApellido
            ),
            addressRl: new FormControl(
              demandante.datosRepresentanteLegal?.direccionPersona?.[0]?.direccionNotificacion
            ),
            municipalityRl: new FormControl(
              demandante.datosRepresentanteLegal?.municipio?.id
            ),
            otroDepartamentoDemandanteRl: new FormControl(
              demandante.datosRepresentanteLegal?.departamentoExtranjero
            ),
            otroMunicipioDemandanteRl: new FormControl(
              demandante.datosRepresentanteLegal?.ciudadExtranjero
            ),
            emailRl: new FormControl(
              demandante.datosRepresentanteLegal?.correoElectronico
            ),
          })
        );
      });
    }
  }

  existeDemandante(demandante: PersonaDto): boolean {
    return this.demandantes.some(
      item =>
        item.idTipoIdentificacion == demandante.idTipoIdentificacion &&
        item.identificacion == demandante.identificacion
    );
  }

  borrarDemandante(id: number, tipoPersona: number) {
    this.demandantes.splice(id, 1);
  }

  /**Fin seccion demandantes */

  /** Seccion demandados */
  guardarDemandadoArray(
    form: FormGroup,
    index: number,
    esProvisional: boolean
  ) {

    this.demandadoComponentes.forEach((comp: FormComponent) => {
      comp.marcarTodoComoTocado();
    });

    const valido = this.validacionTipoPersonaDemandado();

    if (!valido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    const idTipoPersona: number = +form.get('tipoPersonaDemandado')?.value;
    const esPersonaNatural = idTipoPersona === Constants.TIPO_PERSONA.NATURAL;
    const tieneDomicilio: boolean = +form.get('direccionDomicilio')?.value === 1;
    // Crear el demandado según el tipo de persona
    const demandado = esPersonaNatural
      ? this.crearDemandadoNatural(form, tieneDomicilio)
      : this.crearDemandadoJuridico(form, tieneDomicilio);

    if (esProvisional) {
      // Buscar si ya existe una persona con mismo tipo y número de documento
      const indiceExistente = this.demandados.findIndex(
        (d) =>
          d.idTipoIdentificacion == demandado.idTipoIdentificacion &&
          d.identificacion == demandado.identificacion
      );
      if (this.existePersonaDemandado) {
        this.alertaModalService.error(
          this.alertaText['sic-comp-desleal-alertas']['error'],
          this.alertaText['sic-comp-desleal-alertas']['existe']
        );
      } else {
        if (indiceExistente !== -1) {
          // Ya existe → ACTUALIZAR
          const id = this.demandados[indiceExistente].id ?? 0;
          demandado.id = id;
          this.demandados[indiceExistente] = demandado;

          this.alertaModalService.exito(
            this.alertaText['sic-comp-desleal-alertas']['actualizado'],
            this.alertaText['sic-comp-desleal-alertas']['demandado-actualizado']
          );
        } else {
          // No existe → AGREGAR NUEVO
          this.demandados.push(demandado);

          this.alertaModalService.exito(
            this.alertaText['agregado'],
            this.alertaText['demandado-agregado']
          );
        }
        this.deshabilitarAddDemandados = false;
        // Refrescar formulario y estado
        this.submitForm(false, true);
        this.isSaveDemandado = this.validacionTipoPersonaDemandado();
      }
    } else {
      let id: number = 0;

      if (
        demandado.idTipoIdentificacion != 0 &&
        demandado.identificacion != undefined
      ) {
        if (this.existePersonaDemandado == false) {
          if (this.demandados[index] != undefined) {
            // ACTUALIZAR
            id = this.demandados[index].id!;
            demandado.id = id;
            this.demandados[index] = demandado;
            this.deshabilitarAddDemandados = false;
            this.alertaModalService.exito(
              this.alertaText['sic-comp-desleal-alertas']['actualizado'],
              this.alertaText['sic-comp-desleal-alertas']['demandado-actualizado']
            );

            this.isSaveDemandado = this.validacionTipoPersonaDemandado();
          } else {
            // AGREGAR NUEVO
            if (this.existeDemandando(demandado)) {
              this.alertaModalService.error(
                this.alertaText['error'],
                this.alertaText['demandado-ya-agregado']
              );
            } else {
              this.deshabilitarAddDemandados = false;
              this.agregarDemandados(demandado, esPersonaNatural, tieneDomicilio, false);

              this.alertaModalService.exito(
                this.alertaText['agregado'],
                this.alertaText['demandado-agregado']
              );

              this.isSaveDemandado = this.validacionTipoPersonaDemandado();
            }
          }
        } else {
          this.alertaModalService.error(
            this.alertaText['sic-comp-desleal-alertas']['error'],
            this.alertaText['sic-comp-desleal-alertas']['existe']
          );
        }
      } else {
        // this.alertaModalService.error(
        //   this.alertaText['error'],
        //   this.alertaText['sic-comp-desleal-alertas']['tipo-documento-invalido']
        // );
      }
    }

    // Limpiar auxiliares
    this.auxIdCountryDemandado = [];
    this.auxIdCountryRlDemandado = [];
  }

  validacionTipoPersonaDemandado(): boolean {
    if (this.existePersonaDemandado) {
      return false;
    } else {
      if (this.tipoPersonaDemandado == Constants.TIPO_PERSONA.NATURAL) {
        return this.personaDemandadoNaturalValida;
      } else {
        return this.personaDemandadoJuridicoValida;
      }
    }
  }

  guardarDemandadoPrecarga(
    form: PersonaDto,
    esNatural: boolean,
    tieneDomicilio: boolean
  ) {
    form.identificacion = form.numeroOfDocument?.toString();
    form.idTipoIdentificacion = form.typeOfDocument;

    // Elimina propiedades innecesarias
    delete form.numeroOfDocument;
    delete form.typeOfDocument;
    this.agregarDemandados(form, esNatural, tieneDomicilio, false);
    this.deshabilitarAddDemandados = this.validarCamposDemandado(
      {
        form,
        esNatural,
        tieneDomicilio
      });
  }

  validarCamposDemandado(demandado: {
    form: PersonaDto;
    esNatural: boolean;
    tieneDomicilio: boolean;
  }): boolean {
    const persona = demandado.form;
    /** Validaciones comunes */
    if (!persona.idTipoIdentificacion) {
      return true;
    }

    if (!persona.identificacion) {
      return true;
    }

    if (!persona.correoElectronico) {
      return true;
    }

    /** Validaciones específicas según tipo */
    if (demandado.esNatural) {

      if (!persona.primerNombre) {
        return true;
      }
      if (!persona.primerApellido) {
        return true;
      }
    } else {
      if (!persona.razonSocial) {
        return true;
      }

      const rl = persona.datosRepresentanteLegal;
      if (!rl) {
        return true;
      }


      if (!rl.idTipoIdentificacion) {
        return true;
      }
      if (!rl.identificacion) {
        return true;
      }
      if (!rl.primerNombre) {
        return true;
      }
      if (!rl.primerApellido) {
        return true;
      }
      if (!rl.correoElectronico) {
        return true;
      }
    }

    /** Validaciones de domicilio */
    if (demandado.tieneDomicilio) {
      let aux = 0;
      if (persona.municipality) {
        aux = persona.municipality;
      } else if (persona.municipio) {
        aux = persona.municipio.id!
      }
      if (
        !aux ||
        !persona.direccionPersona ||
        !persona.direccionPersona[0]?.direccionNotificacion
      ) {
        return true;
      }

      if (!demandado.esNatural && persona.datosRepresentanteLegal) {
        const rl = persona.datosRepresentanteLegal;
        if (
          !rl.municipio ||
          !rl.direccionPersona ||
          !rl.direccionPersona[0]?.direccionNotificacion
        ) {
          return true;
        }
      }
    }
    return false;
  }



  existeDemandando(demandado: PersonaDto): boolean {
    return this.demandados.some(
      item =>
        item.idTipoIdentificacion == demandado.idTipoIdentificacion &&
        item.identificacion == demandado.identificacion
    );
  }

  // Función auxiliar para crear un demandado natural
  crearDemandadoNatural(form: FormGroup, tieneDomicilio: boolean): PersonaDto {
    const demandadoNatural: PersonaDto = {
      idTipoPersona: form.get('tipoPersonaDemandado')?.value ?? undefined,
      idTipoIdentificacion: form.get('typeOfDocument')?.value ?? undefined,
      identificacion: form.get('numeroOfDocument')?.value ?? undefined,
      primerNombre: form.get('primerNombre')?.value ?? undefined,
      segundoNombre: form.get('segundoNombre')?.value ?? undefined,
      primerApellido: form.get('primerApellido')?.value ?? undefined,
      segundoApellido: form.get('segundoApellido')?.value ?? undefined,
      departamentoExtranjero: form.get('otroDepartamentoDemandado')?.value ?? undefined,
      ciudadExtranjero: form.get('otroMunicipioDemandado')?.value ?? undefined,
      correoElectronico: form.get('correoElectronico')?.value ?? undefined,
      esApoderado: false,
    };

    if (tieneDomicilio) {
      demandadoNatural.direccionPersona = [
        {
          direccionNotificacion: form.get('direccionPersona')?.value,
        },
      ];
      // demandadoNatural.correoElectronico = form.get('correoElectronico')?.value;
      demandadoNatural.municipio = form.get('municipality')?.value
        ? { id: form.get('municipality')?.value }
        : {};
    }

    return demandadoNatural;
  }

  // Función auxiliar para crear un demandado jurídico
  crearDemandadoJuridico(form: FormGroup, tieneDomicilio: boolean): PersonaDto {
    let idTipoPersona: number | null =
      form.get('typeOfDocumentRl')?.value ?? null;

    if (idTipoPersona !== null) {
      idTipoPersona =
        +form.get('typeOfDocumentRl')?.value === 3
          ? Constants.TIPO_PERSONA.JURIDICA
          : Constants.TIPO_PERSONA.NATURAL;
    } else {
      idTipoPersona = null;
    }

    let representanteLegal: PersonaDto | null = {
      idTipoPersona: idTipoPersona,
      idTipoIdentificacion: form.get('typeOfDocumentRl')?.value ?? null,
      identificacion: form.get('numeroOfDocumentRl')?.value ?? null,
      primerNombre: form.get('firstNameRl')?.value ?? undefined,
      segundoNombre: form.get('secondNameRl')?.value ?? undefined,
      primerApellido: form.get('firstLastNameRl')?.value ?? null,
      segundoApellido: form.get('secondLastNameRl')?.value ?? null,
      correoElectronico: form.get('emailRl')?.value ?? null,
      departamentoExtranjero: form.get('otroDepartamentoDemandadoRl')?.value ?? undefined,
      ciudadExtranjero: form.get('otroMunicipioDemandadoRl')?.value ?? undefined,
    };
    if (form.get('municipalityRl')?.value != null) {
      representanteLegal.municipio = {
        id: form.get('municipalityRl')?.value,
      };
    }
    if (this.validarDireccion(form.get('addressRl')?.value)) {
      representanteLegal.direccionPersona = [
        {
          direccionNotificacion: form.get('addressRl')?.value,
        },
      ];
    }
    let allFieldsAreNull = Object.values(representanteLegal).every(value => {
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).every(v => v === null);
      }
      return value === null;
    });

    // Si todas las propiedades son null, asignar representanteLegal como null
    if (allFieldsAreNull) {
      representanteLegal = null;
    }
    const demandadoJuridico: PersonaDto = {
      idTipoPersona: form.get('tipoPersonaDemandado')?.value ?? undefined,
      idTipoIdentificacion: form.get('typeOfDocument')?.value ?? undefined,
      identificacion: form.get('numeroOfDocument')?.value ?? undefined,
      razonSocial: form.get('razonSocial')?.value ?? undefined,
      departamentoExtranjero: form.get('otroDepartamentoDemandado')?.value ?? undefined,
      ciudadExtranjero: form.get('otroMunicipioDemandado')?.value ?? undefined,
      correoElectronico: form.get('correoElectronico')?.value ?? undefined,
      datosRepresentanteLegal: representanteLegal,
    };

    if (tieneDomicilio) {
      demandadoJuridico.direccionPersona =
        form.get('direccionPersona')?.value != undefined
          ? this.validarDireccion(form.get('direccionPersona')?.value)
            ? [
              {
                direccionNotificacion: form.get('direccionPersona')?.value,
              },
            ]
            : null
          : null;
      demandadoJuridico.municipio = form.get('municipality')?.value
        ? { id: form.get('municipality')?.value }
        : {};
    }

    return demandadoJuridico;
  }

  agregarDemandados(
    demandado: PersonaDto,
    esPersonaNatural: boolean,
    tieneDomicilio: boolean,
    esPrecarge: boolean
  ) {
    this.onDemandado = false;
    this.demandados.push(demandado);
    this.addDemandadoArray(esPersonaNatural, tieneDomicilio);
    this.demandados.forEach(element => {
      this.removeDemandadoForm(this.DemandadoArray.length - 1, false, false);
    });
    if (esPrecarge) {
      this.submitForm(false, true);
    }
  }

  obtenerDemandantesYDemandados() {
    if (this.idTramitePrecarga != null) {
      this.tramiteService
        .cargarTramitePendiente(this.idTramitePrecarga)
        .subscribe((resp: TramiteDTO) => {
          if (resp) {
            // Demandantes
            if (resp.demandante.length > 0) {
              this.demandantes = resp.demandante.map(demandante => ({
                ...demandante,
                id: demandante.id,
              }));
            }

            // Demandados
            if (resp.demandado.length > 0) {
              this.demandados = resp.demandado.map(demandado => ({
                ...demandado,
                id: demandado.id,
              }));
            }
            if (resp.apoderado && resp.apoderado.idTipoIdentificacion) {
              this.formApoderado.forEach((elemento: FormField) => {
                switch (elemento.name) {
                  case 'typeOfDocument':
                    elemento.value = resp.apoderado.idTipoIdentificacion;
                    break;
                  case 'numberOfDocument':
                    elemento.value = resp.apoderado.identificacion;
                    break;
                  case 'primerNombre':
                    elemento.value = resp.apoderado.primerNombre;
                    break;
                  case 'segundoNombre':
                    elemento.value = resp.apoderado.segundoNombre;
                    break;
                  case 'primerApellido':
                    elemento.value = resp.apoderado.primerApellido;
                    break;
                  case 'segundoApellido':
                    elemento.value = resp.apoderado.segundoApellido;
                    break;
                  case 'address':
                    elemento.value =
                      resp.apoderado.direccionPersona[0].direccionNotificacion;
                    break;
                  case 'country':
                    elemento.value = resp.apoderado.municipio.idPais;
                    break;
                  case 'departament':
                    elemento.value = resp.apoderado.municipio.idDepartamento;
                    break;
                  case 'municipality':
                    elemento.value = resp.apoderado.municipio.id;
                    break;
                  case 'otroMunicipioApoderado':
                    elemento.value = resp.apoderado.ciudadExtranjero;
                    break;
                  case 'otroDepartamentoApoderado':
                    elemento.value = resp.apoderado.departamentoExtranjero;
                    break;
                  case 'professionalCard':
                    elemento.value = resp.apoderado.tarjetaProfesional!;
                    break;
                  case 'email':
                    elemento.value = resp.apoderado.correoElectronico;
                    break;
                }
              });
            }
          }
        });
    }
  }

  addDemandadoArray(esPersonaNatural: boolean, tieneDomicilio: boolean) {
    if (esPersonaNatural) {
      if (tieneDomicilio) {
        this.demandados.forEach((demandado: PersonaDto) => {
          this.DemandadoArray.push(
            this.fb.group({
              idTipoPersona: new FormControl(demandado.idTipoPersona),
              typeOfDocument: new FormControl(demandado.idTipoIdentificacion),
              numberOfDocument: new FormControl(demandado.identificacion),
              firstName: new FormControl(demandado.primerNombre),
              secondName: new FormControl(demandado.segundoNombre),
              firstLastName: new FormControl(demandado.primerApellido),
              secondLastName: new FormControl(demandado.segundoApellido),
              addressNotificationJudicial: new FormControl(
                demandado.direccionPersona?.[0].direccionNotificacion
              ),
              municipality: new FormControl(demandado.municipio?.id),
              departamentoExtranjero: new FormControl(
                demandado.departamentoExtranjero
              ),
              ciudadExtranjero: new FormControl(demandado.ciudadExtranjero),
              emailNotificationJudicial: new FormControl(
                demandado.correoElectronico
              ),
            })
          );
        });
      } else {
        this.demandados.forEach((demandado: PersonaDto) => {
          this.DemandadoArray.push(
            this.fb.group({
              idTipoPersona: new FormControl(demandado.idTipoPersona),
              typeOfDocument: new FormControl(demandado.idTipoIdentificacion),
              numberOfDocument: new FormControl(demandado.identificacion),
              firstName: new FormControl(demandado.primerNombre),
              secondName: new FormControl(demandado.segundoNombre),
              firstLastName: new FormControl(demandado.primerApellido),
              secondLastName: new FormControl(demandado.segundoApellido),
            })
          );
        });
      }
    } else {
      if (tieneDomicilio) {
        this.demandados.forEach((demandado: PersonaDto) => {
          this.DemandadoArray.push(
            this.fb.group({
              idTipoPersona: new FormControl(demandado.idTipoPersona),
              typeOfDocument: new FormControl(demandado.idTipoIdentificacion),
              numberOfDocumentNIT: new FormControl(demandado.identificacion),
              razonSocial: new FormControl(demandado.razonSocial),
              country: new FormControl(demandado.municipio?.idDepartamento),
              departament: new FormControl(demandado.municipio?.idDepartamento),
              municipality: new FormControl(demandado.municipio?.id),
              email: new FormControl(demandado.correoElectronico),
              typeOfDocumentRl: new FormControl(
                demandado.datosRepresentanteLegal?.idTipoIdentificacion
              ),
              numberOfDocumentRl: new FormControl(
                demandado.datosRepresentanteLegal?.identificacion
              ),
              firstNameRl: new FormControl(
                demandado.datosRepresentanteLegal?.primerNombre
              ),
              secondNameRl: new FormControl(
                demandado.datosRepresentanteLegal?.segundoNombre
              ),
              firstLastNameRl: new FormControl(
                demandado.datosRepresentanteLegal?.primerApellido
              ),
              secondLastNameRl: new FormControl(
                demandado.datosRepresentanteLegal?.segundoApellido
              ),
              addressRl: new FormControl(
                demandado.datosRepresentanteLegal?.direccionPersona?.[0]?.direccionNotificacion
              ),
              countryRl: new FormControl(
                demandado.datosRepresentanteLegal?.municipio?.idDepartamento
              ),
              departamentRl: new FormControl(
                demandado.datosRepresentanteLegal?.municipio?.idDepartamento
              ),
              municipalityRl: new FormControl(
                demandado.datosRepresentanteLegal?.municipio?.id
              ),
              departamentoExtranjero: new FormControl(
                demandado.datosRepresentanteLegal?.departamentoExtranjero
              ),
              ciudadExtranjero: new FormControl(
                demandado.datosRepresentanteLegal?.ciudadExtranjero
              ),
              emailRl: new FormControl(
                demandado.datosRepresentanteLegal?.correoElectronico
              ),
            })
          );
        });
      } else {
        this.demandados.forEach((demandado: PersonaDto) => {
          this.DemandadoArray.push(
            this.fb.group({
              idTipoPersona: new FormControl(demandado.idTipoPersona),
              typeOfDocument: new FormControl(demandado.idTipoIdentificacion),
              numberOfDocumentNIT: new FormControl(demandado.identificacion),
              razonSocial: new FormControl(demandado.razonSocial),
            })
          );
        });
      }
    }
  }

  borrarDemandado(id: number, tipoPersona: number, conoceDomicilio: boolean) {
    this.demandados.splice(id, 1);
  }

  checkIfArrayNotEmpty(): boolean {
    return this.demandados.length > 0;
  }

  /** Fin seccion demandados    */

  /** validacion Botones habilitados */
  onContinuePaso1(form: FormGroup, event: any) {
    const valido = this.tipoClaseSolicitudValida;

    if (!valido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      form.markAllAsTouched();
      return;
    }
    // si es válido → seguir flujo JS
    nextItemAdvanceLineIHorizonal(event);
  }

  continuarDemandante(event: any) {

    this.demandanteComponentes.forEach((comp: FormComponent) => {
      comp.marcarTodoComoTocado();
    });

    const valido = this.validacionTipoPersonaDemandante();

    if (!valido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    const esNatural = this.tipoPersonaDemandante === Constants.TIPO_PERSONA.NATURAL;
    const form = esNatural
      ? this.formGroupDemandanteNatural
      : this.formGroupDemandanteJuridico;
    // Verificar si ya existe
    const indiceExistente = this.demandantes.findIndex(d =>
      d.idTipoIdentificacion == form.get('typeOfDocument')?.value &&
      d.identificacion == form.get('numeroOfDocument')?.value
    );
    if (indiceExistente === -1) {
      this.guardarDemandanteArray(form, indiceExistente, false);
    } else {
      this.guardarDemandanteArray(form, indiceExistente, false);
    }

    nextItemAdvanceLineIHorizonal(event);
  }

  continuarAbogado(event: any) {

    const valido = this.apoderadoValida;

    if (!valido) {
      this.formGroupApoderado.markAllAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    nextItemAdvanceLineIHorizonal(event);
  }

  continuarDemandando(event: any) {

    this.demandadoComponentes.forEach((comp: FormComponent) => {
      comp.marcarTodoComoTocado();
    });

    const valido = this.validacionTipoPersonaDemandado();

    if (!valido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }


    // Verificar si ya existe
    const indiceExistente = this.demandados.findIndex(d =>
      d.idTipoIdentificacion == this.formGroupDemandado.get('typeOfDocument')?.value &&
      d.identificacion == this.formGroupDemandado.get('numeroOfDocument')?.value
    );

    if (indiceExistente === -1) {
      this.guardarDemandadoArray(this.formGroupDemandado, indiceExistente, false);
    } else {
      this.guardarDemandadoArray(this.formGroupDemandado, indiceExistente, false);
    }

    this.submitForm(false, false)
    nextItemAdvanceLineIHorizonal(event);
  }
  /** fin validacion botones habilitados */

  validarDireccion(direccion: string): boolean {
    if (typeof direccion === 'string' && direccion.trim().length > 0) {
      return true;
    }
    // Si llega aquí, no cumple las condiciones
    return false;
  }

  /* 📌 Metodo para envio del formulario */

  subirArchivo(subio: any) {
    this.enviarDocumentos = false;
    if (!subio) {
    } else {
      if (this.submitFinalizar) {
        this.tramiteService.envioAEntidad(this.idTramite!, this.nombreCortoLimpio, this.idiomaActual)
      }
    }
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    this.archivosCargados = archivos;
    const totalBytes = archivos.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / Constants.BYTES_POR_MB).toFixed(2);
    // Convertir el totalBytes a GB
    this.pesoTotalGB = totalBytes / Constants.BYTES_POR_GB;
    if (this.pesoTotalGB > this.valorMaximoGB) {

      this.alertaModalService.error(`El peso total de los archivos (${this.pesoTotalGB.toFixed(2)} GB) supera el límite permitido de ${this.valorMaximoGB} GB.`);
    }
  }

  isNotEmptyAnexo(): boolean {
    const existeAnexo45 = this.archivosCargados.some(
      file => !file.item.requerido && file.files.length > 0
    );
    return existeAnexo45;
  }

  isNotEmptyObligatorio(): boolean {
    const existeAnexo4 = this.archivosCargados.some(
      file => file.item.requerido && file.files.length > 0
    );
    return existeAnexo4;
  }

  isTrueCarga(valor: boolean) {
    this.cargoArchivo = valor;
  }

  saveWithoutSending() {
    this.submitFinalizar = false;
    this.submitForm(false, true);
  }

  finalizar() {

    // Validar anexos obligatorios
    if (!this.isNotEmptyObligatorio()) {
      this.alertaModalService.error(
        this.alertaText['sic-comp-desleal-alertas']['error-documentos-adicionales']
      );
      return;
    }

    // Validar formularios
    if (!this.formulariosValidos()) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    // Validar peso máximo permitido
    if (this.pesoTotalGB > this.valorMaximoGB) {
      this.alertaModalService.error(`El peso total de los archivos (${this.pesoTotalGB.toFixed(2)} GB) supera el límite permitido de ${this.valorMaximoGB} GB.`);
      return;
    }

    if (!this.confirmacionEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['ley_2213']
      );
      return;
    }
    if (!this.seleccionAceptoRechazoEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['envio_demanda']
      );
      return;
    }

    // Si NO hay anexos adicionales → pedir confirmación
    if (!this.isNotEmptyAnexo()) {
      this.alertaModalService.confirmacion(
        this.alertaText['sic-comp-desleal-alertas']['desea-continuar'],
        this.alertaText['sic-comp-desleal-alertas']['documentos-adicionales'],
        () => this.sendDocumentos(), // Aceptar
        () => { }                      // Cancelar
      );
      return;
    }

    // Si todo está OK → enviar
    this.sendDocumentos();
  }

  sendDocumentos() {
    this.enviarDocumentos = false;
    this.submitFinalizar = true;
    this.submitForm(true, false);
  }

  submitFormDemandante(index: number, esProvisional: boolean) {
    const form = this.tipoPersonaDemandante === Constants.TIPO_PERSONA.NATURAL
      ? this.formGroupDemandanteNatural
      : this.formGroupDemandanteJuridico;
    this.guardarDemandanteArray(
      form,
      index,
      esProvisional
    );
  }

  submitFormDemandado(index: number, esProvisional: boolean) {
    this.guardarDemandadoArray(this.formGroupDemandado, index, esProvisional);
  }

  obtenerNombreSolicitud(): string {
    const id = this.formGroupClaseSolicitud.get('claseOfSolicitation')?.value;
    const clase = this.listaClaseSolicitud
      .find(field => field.Id === id);
    if (clase) {
      return clase.Nombre;
    }
    return '';
  }

  obtenerAsuntoYSolicitud(): { claseSolicitud: number; asunto: number } {
    let json: { claseSolicitud: number; asunto: number } = {
      claseSolicitud: 0,
      asunto: 0,
    };
    if (this.formGroupClaseSolicitud.valid) {
      json = {
        claseSolicitud: this.formGroupClaseSolicitud.get('claseOfSolicitation')
          ?.value,
        asunto: this.formGroupClaseSolicitud.get('asuntoField')?.value,
      };
    } else {
      this.formClaseSolicitud.forEach((field: FormField) => {
        if (field.name == 'claseOfSolicitation') {
          json.claseSolicitud = +field.value!;
        } else if (field.name == 'asuntoField') {
          json.asunto = +field.value!;
        }
      });
    }
    return json;
  }

  obtenerApoderado() {
    let json!: PersonaDto | undefined;
    let apoderado: PersonaDto = {
      idTipoIdentificacion:
        +this.formGroupApoderado.get('typeOfDocument')?.value,
      idTipoPersona: Constants.TIPO_PERSONA.NATURAL,
      identificacion: this.formGroupApoderado.get('numberOfDocument')?.value,
      correoElectronico: this.formGroupApoderado.get('email')?.value,
      primerNombre: this.formGroupApoderado.get('primerNombre')?.value,
      segundoNombre: this.formGroupApoderado.get('segundoNombre')?.value,
      primerApellido: this.formGroupApoderado.get('primerApellido')?.value,
      segundoApellido: this.formGroupApoderado.get('segundoApellido')?.value,
      tarjetaProfesional:
        this.formGroupApoderado.get('professionalCard')?.value,
      esApoderado: true,
      departamentoExtranjero: this.formGroupApoderado.get(
        'otroDepartamentoApoderado'
      )?.value,
      ciudadExtranjero: this.formGroupApoderado.get('otroMunicipioApoderado')
        ?.value,
    };
    if (this.formGroupApoderado.get('municipality')?.value != null) {
      apoderado.municipio = {
        id: this.formGroupApoderado.get('municipality')?.value,
      };
    }
    if (this.validarDireccion(this.formGroupApoderado.get('address')?.value)) {
      apoderado.direccionPersona = [
        {
          direccionNotificacion: this.formGroupApoderado.get('address')?.value,
        },
      ];
    }
    if (this.onApoderado == false) {
      if (this.apoderadoPrecarga) {
        apoderado.id = this.apoderadoPrecarga.id;
      }
      json = apoderado;
    } else {
      if (this.apoderadoPrecarga) {
        apoderado.id = this.apoderadoPrecarga.id!;
        apoderado.esApoderado = true;
      }
      apoderado.idTipoPersona = Constants.TIPO_PERSONA.NATURAL;
      json = apoderado;
    }
    // if (this.formGroupApoderado.invalid) {
    //   json = undefined;
    // }
    return json;
  }

  validarApoderado(valor: string | undefined) {
    if (typeof valor === 'string' && valor.trim().length > 0) {
      return true;
    }
    // Si llega aquí, no cumple las condiciones
    return false;
  }

  setIdTipoTramite(idAsunto: number) {
    switch (idAsunto) {
      case AsuntoTramiteConstants.ID_ASUNTO_SIC_COMP_DES:
        return TipoTramiteConstants.ID_TRAMITE_SIC_COMP_DES;
      case AsuntoTramiteConstants.ID_ASUNTO_SIC_PROP_IND:
        return TipoTramiteConstants.ID_TRAMITE_SIC_PROP_IND;
      case AsuntoTramiteConstants.ID_ASUNTO_SIC_PROIND_COMDES:
        return TipoTramiteConstants.ID_TRAMITE_SIC_PROIND_COMDES;
    }
    return 0;
  }

  private transformarMunicipality(arr: any[]): any[] {
    return arr?.map(item => {
      if (item?.municipality !== undefined && item?.municipality !== null) {
        item.municipio = { id: item.municipality };
        delete item.municipality;
      }
      return item;
    }) ?? [];
  }

  submitForm(isEnviar: boolean, showAlert: boolean) {
    this.enviarEntidad = isEnviar;
    let id: number | null = 0;
    if (this.idTramite != null) {
      id = this.idTramite;
    } else if (this.idTramiteObtentorCompentenciaDesleal != undefined) {
      id = this.idTramiteObtentorCompentenciaDesleal;
    } else {
      id = null;
    }
    const demandantesTransformados = this.transformarMunicipality(this.demandantes);
    const demandadosTransformados = this.transformarMunicipality(this.demandados);

    const tramite: TramiteSicCompetenciaDeslealDto = {
      id: id,
      enviar: isEnviar,
      idTipoTramite: this.setIdTipoTramite(this.obtenerAsuntoYSolicitud().asunto),
      claseSolicitud: {
        id: this.obtenerAsuntoYSolicitud().claseSolicitud,
        nombre: this.obtenerNombreSolicitud(),
      },
      asunto: { id: this.obtenerAsuntoYSolicitud().asunto },
      usuario: { id: this.dataUsuario?.idUsuario! },
      tieneApoderado: true,
      demandante: demandantesTransformados,
      demandado: demandadosTransformados,
      fechaCreacion: new Date().toISOString(),
      tipoTramiteNombreCorto: this.nombreCortoLimpio,
      enviarCorreoDemandado: this.enviarCorreoDemandado,
      idioma: this.idiomaActual,
    };
    tramite.apoderado = this.obtenerApoderado();
    this.spinner.hide();
    this.tramiteSicService
      .crearTramiteCompentenciaDesleal(tramite)
      .subscribe(response => {
        if (response.success) {
          this.submitAction.emit(this.formGroupButton);
          this.idTramiteObtentorCompentenciaDesleal = response.data.Id;
          if (isEnviar == false) {
            if (showAlert) {
              this.alertaModalService.exito(
                this.alertaText['proceso-guardado-exitosamente']
              );
            }
            this.enviarDocumentos = true;
            this.idTramitePrecarga = response.data.Id;
            this.obtenerDemandantesYDemandados();
          } else {
            this.enviarDocumentos = true;
            this.alertaModalService
              .exito(
                this.alertaText['proceso-enviado'],
                this.alertaText['sic-comp-desleal-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad)
              )
              .then(() => {
                this.router.navigate(['/expediente']);
              });
          }
        } else {
          this.alertaModalService.error(response.message);
        }
      });
  }

  async callServiceCrearTramite(): Promise<{
    success: boolean;
    message?: string;
  }> {
    let id: number | null = 0;
    if (this.idTramite != null) {
      id = this.idTramite;
    } else if (this.idTramiteObtentorCompentenciaDesleal != undefined) {
      id = this.idTramiteObtentorCompentenciaDesleal;
    } else {
      id = null;
    }
    if (this.tipoPersonaDemandante) {
      const esNatural: boolean =
        this.tipoPersonaDemandante ===
        Constants.TIPO_PERSONA.NATURAL;
      let form = esNatural ? this.formGroupDemandanteNatural : this.formGroupDemandanteJuridico;
      if (this.DemandanteArray.value.length > this.demandantes.length) {
        // Valida si existe el demandante con tipo y número de identificación duplicados
        if (!this.existePersonaDemandante) {
          const demandante = this.crearDemandante(
            form,
            esNatural
          );
          this.agregarDemandante(demandante, esNatural, false);
        }
      } else {
        if (!this.existePersonaDemandante) {
          const demandante = this.crearDemandante(
            form,
            esNatural
          );
          const indiceExistente = this.demandantes.findIndex(d =>
            d.idTipoIdentificacion === demandante.idTipoIdentificacion &&
            d.identificacion === demandante.identificacion
          );
          this.demandantes[indiceExistente] = demandante;
        }
      }
    }

    if (this.formGroupDemandado.get('tipoPersonaDemandado')?.value != undefined) {
      let idTipoPersona: number = +this.formGroupDemandado.get(
        'tipoPersonaDemandado'
      )?.value;
      let esPersonaNatural =
        idTipoPersona === Constants.TIPO_PERSONA.NATURAL;
      let tieneDomicilio: boolean =
        +this.formGroupDemandado.get('direccionDomicilio')?.value === 1;
      let demandado: PersonaDto;



      if (this.DemandadoArray.value.length > this.demandados.length) {
        if (!this.existePersonaDemandado) {
          // Construir demandado según tipo de persona y domicilio
          if (esPersonaNatural) {
            demandado = this.crearDemandadoNatural(
              this.formGroupDemandado,
              tieneDomicilio
            );
          } else {
            demandado = this.crearDemandadoJuridico(
              this.formGroupDemandado,
              tieneDomicilio
            );
          }
          this.agregarDemandados(
            demandado,
            esPersonaNatural,
            tieneDomicilio,
            false
          );
        }
      } else {
        if (!this.existePersonaDemandado) {
          if (esPersonaNatural) {
            demandado = this.crearDemandadoNatural(
              this.formGroupDemandado,
              tieneDomicilio
            );
          } else {
            demandado = this.crearDemandadoJuridico(
              this.formGroupDemandado,
              tieneDomicilio
            );
          }
          const indiceExistente = this.demandados.findIndex(d =>
            d.idTipoIdentificacion === demandado.idTipoIdentificacion &&
            d.identificacion === demandado.identificacion
          );
          this.demandados[indiceExistente] = demandado;
        }
      }
    }

    const tramite: TramiteSicCompetenciaDeslealDto = {
      id: id,
      enviar: false,
      idTipoTramite: this.setIdTipoTramite(this.obtenerAsuntoYSolicitud().asunto),
      claseSolicitud: {
        id: this.obtenerAsuntoYSolicitud().claseSolicitud,
        nombre: this.obtenerNombreSolicitud(),
      },
      asunto: { id: this.obtenerAsuntoYSolicitud().asunto },
      usuario: { id: this.dataUsuario?.idUsuario! },
      tieneApoderado: true,
      demandante: this.demandantes,
      demandado: this.demandados,
      fechaCreacion: new Date().toISOString(),
      tipoTramiteNombreCorto: this.nombreCortoLimpio,
      idioma: this.idiomaActual,
    };
    tramite.apoderado = this.obtenerApoderado();
    try {
      const response = await firstValueFrom(
        this.tramiteSicService.crearTramiteCompentenciaDesleal(tramite)
      );

      if (response.success) {
        this.enviarDocumentos = this.archivosCargados.length > 0;
        await this.alertaModalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          this.alertaText['sic-comp-desleal-alertas']['tramite-enviado-mensaje']
            .replace('{{proceso}}', this.proceso)
        );
        return { success: true };
      } else {
        // await this.alertaModalService.error(
        //   'Error al crear la solicitud',
        //   response.message || 'Ocurrió un error al intentar crear la solicitud.'
        // );
        return { success: false };
      }
    } catch (error) {
      // await this.alertaModalService.error(
      //   'Error inesperado',
      //   'Ocurrió un error inesperado. Por favor, intente de nuevo más tarde.'
      // );
      return { success: false, message: 'Error al guardar' };
    }
  }

  getIdDocumento(tipoDocumento: string): number {
    if (typeof tipoDocumento == 'string') {
      const documento = this.dominios.find(
        (elemento: any) => elemento.TipoDocumento === tipoDocumento
      );
      return +documento?.Id!;
    } else {
      return tipoDocumento[0];
    }
  }

  /* 📌 Metodos para el tab active*/

  setActiveTabDemandantes(index: number): void {
    this.activeTabIndexDemandantes = index;
  }

  setActiveTabDemandandos(index: number): void {
    this.activeTabIndexDemandados = index;
  }

  getData() {
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    if (user_type.Nombre == 'Abogado') {
      if (this.dataUsuario) {
        this.getDataUsuario(this.dataUsuario?.idPersona!);
      }
      return;
    }

    // Mostrar formulario según tipo de persona
    this.tipoPersonaDemandante = this.dataUsuario?.tipoPersona!;
    const esNatural = this.dataUsuario?.tipoPersona === Constants.TIPO_PERSONA.NATURAL;
    this.personaDemandanteNaturalValida = esNatural;
    this.personaDemandanteJuridicoValida = !esNatural;

    // Si el país es extranjero
    if (this.dataUsuario?.pais !== 1) {
      this.formGroupDemandanteNatural.get('country')?.setValue(this.dataUsuario?.pais)
      this.auxIdCountryDemandante.push(
        this.formGroupDemandanteNatural.get('country')?.value
      );
      this._cuentaService.getDataPersonal(this.dataUsuario!.idUsuario!).subscribe((response: any) => {
        const otroDepartamento = response.data.Otro_Departamento;
        const otroMunicipio = response.data.Otro_Municipio;
        this.mapearFormularioDemandante(otroDepartamento, otroMunicipio, esNatural);
        this.formDemandante[0].forEach((field: FormField) => {
          if (field.name === 'otroDepartamentoDemandante' || field.name === 'otroMunicipioDemandante') {
            field.required = true;
          }
        });
      });
    } else {
      // Si es nacional, se pasa directamente lo que ya tiene el usuario
      const otroDepartamento = this.dataUsuario?.otroDepartamento ?? '';
      const otroMunicipio = this.dataUsuario?.otroMunicipio ?? '';
      this.mapearFormularioDemandante(otroDepartamento, otroMunicipio, esNatural);
    }
  }

  private mapearFormularioDemandante(otroDepartamento: string, otroMunicipio: string, esNatural: boolean) {
    if (esNatural) {
      const personaNatural: PersonaDto = {
        tipoPersonaDemandante: this.dataUsuario?.tipoPersona,
        typeOfDocument: this.getIdDocumento(String(this.dataUsuario?.tipoDocumento)),
        numeroOfDocument: +this.dataUsuario?.identificacion!,
        primerNombre: this.dataUsuario?.primerNombre,
        segundoNombre: this.dataUsuario?.segundoNombre,
        primerApellido: this.dataUsuario?.primerApellido,
        segundoApellido: this.dataUsuario?.segundoApellido,
        correoElectronico: this.dataUsuario?.correoElectronico,
        country: this.dataUsuario?.pais,
        departament: this.dataUsuario?.departamento,
        municipality: this.dataUsuario?.municipio,
        otroDepartamentoDemandante: otroDepartamento,
        otroMunicipioDemandante: otroMunicipio,
        direccionPersona: [
          {
            direccionNotificacion:
              this.dataUsuario?.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ??
              this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
          },
        ],
      };

      this.formDemandante[0] = this.formDemandante[0].map(field => {
        let value = personaNatural[field.name as keyof typeof personaNatural];
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[0]?.direccionNotificacion;
        }
        // Valida el tipo y asignar solo si es compatible
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          field.value = value;
        }
        return field;
      });

      this.showObligation('naturalDemandante', 0, 0);
    } else {
      const personaJuridica: PersonaDto = {
        idTipoPersona: this.dataUsuario?.tipoPersona,
        typeOfDocument: this.getIdDocumento(String(this.dataUsuario?.tipoDocumento)),
        numeroOfDocument: +this.dataUsuario?.identificacion!,
        razonSocial: this.dataUsuario?.razonSocial,
        country: this.dataUsuario?.pais,
        departament: this.dataUsuario?.departamento,
        municipality: this.dataUsuario?.municipio,
        otroDepartamento: otroDepartamento,
        otroMunicipio: otroMunicipio,
        direccionPersona: [
          {
            direccionNotificacion:
              this.dataUsuario?.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ??
              this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
          },
        ],
        correoElectronico: this.dataUsuario?.correoElectronico,
      };

      this.formDemandante[0] = this.formDemandante[0].map(field => {
        let value = personaJuridica[field.name as keyof typeof personaJuridica];
        if (Array.isArray(value)) {
          value = value[0]?.direccionNotificacion;
        }
        // Valida el tipo y asignar solo si es compatible
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          field.value = value;
          if (field.name === 'numeroOfDocument') {
            field.label = this.comunText['nit'];
          }
        }
        return field;
      });

      this.showObligation('juridicoDemandante', 0, 0);
    }
  }

  getDataUsuario(idPersona: number) {
    this.datosProvisionalesService.getDataAbogado(idPersona).subscribe((responseAbogado: any) => {
      if (responseAbogado.datoAdicionalAbogado) {
        const tarjeta = responseAbogado.datoAdicionalAbogado.Tarjeta_Profesional;

        if (this.dataUsuario?.pais !== 1) {
          this.formGroupApoderado?.get('country')?.setValue(this.dataUsuario?.pais);
          this.auxIdCountryApoderado.push(this.formGroupApoderado?.get('country')?.value);

          this._cuentaService.getDataPersonal(this.dataUsuario!.idUsuario!).subscribe((responseExtranjero: any) => {
            const otroDep = responseExtranjero.data.Otro_Departamento;
            const otroMun = responseExtranjero.data.Otro_Municipio;

            this.mapearFormulario(tarjeta, otroDep, otroMun, true);
            this.formGroupApoderado?.controls['otroDepartamentoApoderado']?.addValidators(
              Validators.required
            );
            this.formGroupApoderado?.controls['otroMunicipioApoderado']?.addValidators(
              Validators.required
            );
            this.formGroupApoderado.get('otroDepartamentoApoderado')?.updateValueAndValidity();
            this.formGroupApoderado.get('otroMunicipioApoderado')?.updateValueAndValidity();
          });
        } else {
          this.mapearFormulario(tarjeta, this.dataUsuario?.otroDepartamento, this.dataUsuario?.otroMunicipio, false);
        }
      }
    });
  }

  private mapearFormulario(tarjeta: number, otroDepartamento: string | undefined, otroMunicipio: string | undefined, requerido: boolean) {
    setTimeout(() => {
      this.formApoderado = this.formApoderado.map(
        (field: FormField) => {
          switch (field.name) {
            case 'primerNombre':
              field.value = this.dataUsuario?.primerNombre ?? undefined;
              break;
            case 'segundoNombre':
              field.value = this.dataUsuario?.segundoNombre ?? undefined;
              break;
            case 'primerApellido':
              field.value = this.dataUsuario?.primerApellido ?? undefined;
              break;
            case 'segundoApellido':
              field.value = this.dataUsuario?.segundoApellido ?? undefined;
              break;
            case 'typeOfDocument':
              field.value = this.getIdDocumento(
                String(this.dataUsuario?.tipoDocumento)
              ) ?? undefined;
              break;
            case 'numberOfDocument':
              field.value = this.dataUsuario?.identificacion ?? undefined;
              break;
            case 'country':
              field.value = this.dataUsuario?.pais ?? undefined;
              break;
            case 'departament':
              field.value = this.dataUsuario?.departamento ?? undefined;
              break;
            case 'municipality':
              field.value = this.dataUsuario?.municipio ?? undefined;
              break;
            case 'otroDepartamentoApoderado':
              field.required = requerido;
              field.value = otroDepartamento ?? undefined;
              break;
            case 'otroMunicipioApoderado':
              field.required = requerido;
              field.value = otroMunicipio ?? undefined;
              break;
            case 'email':
              field.value = this.dataUsuario?.correoElectronico ?? undefined;;
              break;
            case 'address':
              field.value = this.dataUsuario?.direccion?.find(
                (elemento: {
                  Direccion_Notificacion?: string;
                  Es_Primaria?: boolean;
                  Id?: number
                }) => elemento.Es_Primaria
              )?.Direccion_Notificacion ??
                this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '';
              break;
            case 'professionalCard':
              field.value = tarjeta ?? undefined;
              break;

          }
          return field;
        }
      );
    }, 800)
  }

  validarUsuario(
    tipo: number,
    numero: string,
    form: FormGroup,
    tipoPersona: string,
    indice: number
  ) {
    this.serviceLista
      .persona(tipo, numero)
      .subscribe((resp: PersonaConsultadaDTO) => {
        if (resp) {
          if (tipoPersona == 'apoderado') {
            this.setearFormApoderado(resp);
          } else if (tipoPersona == 'demandante') {
            this.seteatFormDemandante(resp, indice);
          } else {
            const direccionDomicilio = form.get('direccionDomicilio')?.value;
            this.seteatFormDemandado(resp, direccionDomicilio, form, indice);
          }
        } else {
          if (tipoPersona == 'demandado') {
            const direccionDomicilio = form.get('direccionDomicilio')?.value;
            const tipoPersona = form.get('tipoPersonaDemandado')?.value;
            this.formDemandado[indice] = this.formDemandado[indice].map(
              field => {
                if (field.name == 'typeOfDocument') {
                  field.value = tipo;
                } else if (field.name == 'tipoPersonaDemandado') {
                  field.value = tipoPersona;
                } else if (field.name == 'numeroOfDocument') {
                  field.value = numero;
                } else if (field.name == 'direccionDomicilio') {
                  field.value = direccionDomicilio;
                  field.disabled = false;
                } else {
                  field.value = undefined;
                  field.disabled = false;
                }
                return field;
              }
            );
          }
        }
      });
  }

  setearFormApoderado(response: PersonaConsultadaDTO) {
    response = this.textTransformService.transformarAMayusculas(response);
    if (response.Id_Tipo_Persona === Constants.TIPO_PERSONA.NATURAL) {
      this.formApoderado = this.formApoderado.map((field: FormField) => {
        switch (field.name) {
          case 'typeOfDocument':
            field.value = response.Id_Tipo_Identificacion;
            break;
          case 'numberOfDocument':
            field.value = response.Identificacion;
            break;
          case 'primerNombre':
            field.value = response.Persona_Natural[0].Primer_nombre;
            break;
          case 'segundoNombre':
            field.value = response.Persona_Natural[0].Segundo_nombre;
            break;
          case 'primerApellido':
            field.value = response.Persona_Natural[0].Primer_apellido;
            break;
          case 'segundoApellido':
            field.value = response.Persona_Natural[0].Segundo_apellido;
            break;
          case 'address':
            field.value =
              response.Direccion_Persona.find(
                (elemento: {
                  Direccion_Notificacion?: string;
                  Es_Primaria?: boolean;
                  Id?: number;
                }) => elemento.Es_Primaria
              )?.Direccion_Notificacion ?? '';
            break;
          case 'country':
            field.value = response.Municipio
              ? response.Municipio.Departamento.Pais.Id
              : undefined;
            break;
          case 'departament':
            field.value = response.Municipio
              ? response.Municipio.Departamento.Id
              : undefined;
            break;
          case 'municipality':
            field.value = response.Municipio
              ? response.Municipio.Id
              : undefined;
            break;
          case 'otroMunicipioApoderado':
            field.value = response.Otro_Municipio;
            break;
          case 'otroDepartamentoApoderado':
            field.value = response.Otro_Departamento;
            break;
          case 'professionalCard':
            field.value = response.Tarjeta_profesional;
            break;
          case 'email':
            field.value = response.Correo_electronico;
            break;
        }
        return field;
      });
    } else {
      this.formApoderado = this.formApoderado.map((field: FormField) => {
        switch (field.name) {
          case 'typeOfDocument':
            field.value = response.Id_Tipo_Identificacion;
            break;
          case 'numberOfDocument':
            field.value = response.Identificacion;
            break;
          case 'address':
            field.value =
              response.Direccion_Persona.find(
                (elemento: {
                  Direccion_Notificacion?: string;
                  Es_Primaria?: boolean;
                  Id?: number;
                }) => elemento.Es_Primaria
              )?.Direccion_Notificacion ?? '';
            break;
          case 'country':
            field.value = response.Municipio.Departamento.Pais.Id;
            break;
          case 'departament':
            field.value = response.Municipio.Departamento.Id;
            break;
          case 'otroDepartamentoApoderado':
            field.value = response.Otro_Municipio;
            break;
          case 'otroMunicipioApoderado':
            field.value = response.Otro_Departamento;
            break;
          case 'professionalCard':
            field.value = response.Tarjeta_profesional;
            break;
          case 'email':
            field.value = response.Correo_electronico;
            break;
        }
        return field;
      });
    }
  }

  seteatFormDemandante(response: PersonaConsultadaDTO, indice: number) {
    response = this.textTransformService.transformarAMayusculas(response);
    if (response.Id_Tipo_Persona == Constants.TIPO_PERSONA.NATURAL) {
      const personaNatural: PersonaDto = {
        tipoPersonaDemandante: response.Id_Tipo_Persona,
        typeOfDocument: response.Id_Tipo_Identificacion,
        numeroOfDocument: response.Identificacion,
        primerNombre: response.Persona_Natural[0].Primer_nombre,
        segundoNombre: response.Persona_Natural[0].Segundo_nombre,
        primerApellido: response.Persona_Natural[0].Primer_apellido,
        segundoApellido: response.Persona_Natural[0].Segundo_apellido,
        correoElectronico: response.Correo_electronico,
        country: response.Municipio
          ? response.Municipio.Departamento.Pais.Id
          : undefined,
        departament: response.Municipio
          ? response.Municipio.Departamento.Id
          : undefined,
        municipality: response.Municipio ? response.Municipio.Id : undefined,
        direccionPersona: [
          {
            direccionNotificacion:
              response.Direccion_Persona.find(
                (elemento: {
                  Direccion_Notificacion?: string;
                  Es_Primaria?: boolean;
                  Id?: number;
                }) => elemento.Es_Primaria
              )?.Direccion_Notificacion ?? '',
          },
        ],
      };
      this.formDemandante[indice] = this.formDemandante[indice].map(field => {
        let value = personaNatural[field.name as keyof typeof personaNatural];
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[indice]?.direccionNotificacion;
        }

        // Valida el tipo y asignar solo si es compatible
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          field.value = value;
        }

        return field;
      });
    } else {
      const personaJuridica: PersonaDto = {
        tipoPersonaDemandante: response.Id_Tipo_Persona,
        typeOfDocument: response?.Id_Tipo_Identificacion,
        numeroOfDocument: +response.Identificacion,
        razonSocial:
          response.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0]
            .Razon_Social,
        country: response.Municipio
          ? response.Municipio.Departamento.Pais.Id
          : undefined,
        departament: response.Municipio
          ? response.Municipio.Departamento.Id
          : undefined,
        municipality: response.Municipio ? response.Municipio.Id : undefined,

        direccionPersona: [
          {
            direccionNotificacion:
              response.Direccion_Persona.find(
                (elemento: {
                  Direccion_Notificacion?: string;
                  Es_Primaria?: boolean;
                  Id?: number;
                }) => elemento.Es_Primaria
              )?.Direccion_Notificacion ?? '',
          },
        ],
        correoElectronico: response.Correo_electronico,
      };
      this.formDemandante[indice] = this.formDemandante[indice].map(field => {
        let value = personaJuridica[field.name as keyof typeof personaJuridica];
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[indice]?.direccionNotificacion;
        }

        // Valida el tipo y asignar solo si es compatible
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          field.value = value;
        }

        return field;
      });
    }
  }

  seteatFormDemandado(
    response: PersonaConsultadaDTO,
    direccionDomicilio: number,
    form: FormGroup,
    indice: number
  ) {
    response = this.textTransformService.transformarAMayusculas(response);
    if (response.Id_Tipo_Persona == Constants.TIPO_PERSONA.NATURAL) {
      const personaNatural: PersonaDto = {
        tipoPersonaDemandado: response.Id_Tipo_Persona,
        direccionDomicilio: direccionDomicilio,
        typeOfDocument: response.Id_Tipo_Identificacion,
        numeroOfDocument: response.Identificacion,
        primerNombre: response.Persona_Natural[0].Primer_nombre,
        segundoNombre: response.Persona_Natural[0].Segundo_nombre,
        primerApellido: response.Persona_Natural[0].Primer_apellido,
        segundoApellido: response.Persona_Natural[0].Segundo_apellido,
        correoElectronico: response.Correo_electronico,
        country: response.Municipio
          ? response.Municipio.Departamento.Pais.Id
          : undefined,
        departament: response.Municipio
          ? response.Municipio.Departamento.Id
          : undefined,
        municipality: response.Municipio ? response.Municipio.Id : undefined,
        direccionPersona: [
          {
            direccionNotificacion:
              response.Direccion_Persona[0].Direccion_Notificacion,
          },
        ],
      };
      if (personaNatural.direccionDomicilio == 2) {
        delete personaNatural.country;
        delete personaNatural.departament;
        delete personaNatural.municipality;
      }
      for (let control in form.controls) {
        if (
          personaNatural[control as keyof typeof personaNatural] !== undefined
        ) {
          form
            .get(control)
            ?.setValue(personaNatural[control as keyof typeof personaNatural]);
        }
      }
      this.formDemandado[indice] = this.formDemandado[indice].map(field => {
        let value = personaNatural[field.name as keyof typeof personaNatural];
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[indice]?.direccionNotificacion;
        }
        // Valida el tipo y asignar solo si es compatible
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          if (
            field.name === 'direccionPersona' ||
            field.name === 'correoElectronico'
          ) {
            field.value = 'LEY DE PROTECCIÓN DE DATOS PERSONALES';
          } else {
            field.value = value;
          }
        }

        return field;
      });
      this.deshabilitarInputsDemandado(indice);
    } else {
      const personaJuridica: PersonaDto = {
        tipoPersonaDemandado: response?.Id_Tipo_Persona,
        typeOfDocument: response?.Id_Tipo_Identificacion,
        numeroOfDocument: response?.Identificacion,
        direccionDomicilio: direccionDomicilio,
        razonSocial:
          response.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0]
            .Razon_Social,
        country: response.Municipio
          ? response.Municipio.Departamento.Pais.Id
          : undefined,
        departament: response.Municipio
          ? response.Municipio.Departamento.Id
          : undefined,
        municipality: response.Municipio ? response.Municipio.Id : undefined,
        correoElectronico: response?.Correo_electronico,
        direccionPersona: [
          {
            direccionNotificacion:
              response.Direccion_Persona[0].Direccion_Notificacion,
          },
        ],
      };
      if (personaJuridica.direccionDomicilio == 2) {
        delete personaJuridica.country;
        delete personaJuridica.departament;
        delete personaJuridica.municipality;
      }
      for (let control in form.controls) {
        if (
          personaJuridica[control as keyof typeof personaJuridica] !== undefined
        ) {
          form
            .get(control)
            ?.setValue(
              personaJuridica[control as keyof typeof personaJuridica]
            );
        }
      }
      this.formDemandado[indice] = this.formDemandado[indice].map(field => {
        let value = personaJuridica[field.name as keyof typeof personaJuridica];
        if (typeof value === 'object' && Array.isArray(value)) {
          value = value[indice]?.direccionNotificacion;
        }

        // Valida el tipo y asignar solo si es compatible
        if (
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean')
        ) {
          if (
            field.name === 'direccionPersona' ||
            field.name === 'correoElectronico'
          ) {
            field.value = 'LEY DE PROTECCIÓN DE DATOS PERSONALES';
          } else {
            field.value = value;
          }
        }

        return field;
      });
      this.deshabilitarInputsDemandado(indice);
    }
  }

  deshabilitarInputsDemandado(indice: number) {
    this.formDemandado[indice] = this.formDemandado[indice].map(field => {
      if (
        ['typeOfDocument', 'numeroOfDocument', 'tipoPersonaDemandado'].includes(
          field.name
        )
      ) {
        field.disabled = false;
      } else {
        if (field.name.includes('Rl')) {
          field.disabled = false;
        } else {
          field.disabled = true;
        }
      }
      return field;
    });
  }

  showObligation(typeForm: string, indice: number, direccionDomicilio: number) {
    if (typeForm == 'naturalDemandante') {
      this.formDemandante[indice].forEach((field: FormField) => {
        if (field.name === 'primerNombre' || field.name === 'primerApellido') {
          field.required = true;
        }
      });
    } else if (typeForm == 'juridicoDemandante') {
      this.formDemandante[indice].forEach((field: FormField) => {
        if (
          [
            'razonSocial',
            'typeOfDocumentRl',
            'numeroOfDocumentRl',
            'firstNameRl',
            'firstLastNameRl',
            'addressRl',
            'countryRl',
            'departamentRl',
            'municipalityRl',
            'emailRl',
          ].includes(field.name)
        ) {
          field.required = true;
        }
      });
    } else if (typeForm == 'naturalDemandando') {
      this.formDemandado[indice].forEach((field: FormField) => {
        if (
          [
            'direccionDomicilio',
            'primerNombre',
            'primerApellido',
            'direccionPersona',
          ].includes(field.name)
        ) {
          field.required = true;
        }
      });
    } else if (typeForm == 'juridicoDemandado') {
      this.formDemandado[indice].forEach((field: FormField) => {
        if (
          [
            'direccionDomicilio',
            'razonSocial',
            'typeOfDocumentRl',
            'numeroOfDocumentRl',
            'firstNameRl',
            'firstLastNameRl',
          ].includes(field.name)
        ) {
          field.required = true;
        }
      });
      this.formDemandado[indice].forEach((field: FormField) => {
        if (
          [
            'addressRl',
            'countryRl',
            'departamentRl',
            'municipalityRl',
          ].includes(field.name)
        ) {
          if (direccionDomicilio == 1) {
            field.required = true;
          } else {
            field.required = false;
          }
        }
      });
    }
  }

  get correoDemandado(): string {
    const correos = this.demandados.map((elem) => elem.correoElectronico);
    return correos.length > 1
      ? `${correos.slice(0, -1).join(', ')}, ${correos.slice(-1)}`
      : `${correos[0]}`
  }

  get nombreDemandado(): string {
    const nombres = this.demandados.map((elem) =>
      elem.idTipoPersona === Constants.TIPO_PERSONA.NATURAL
        ? `${elem.primerNombre ?? ''} ${elem.segundoNombre ?? ''} ${elem.primerApellido ?? ''} ${elem.segundoApellido ?? ''}`.trim()
        : elem.razonSocial
    );

    return nombres.length > 1
      ? `${nombres.slice(0, -1).join(', ')}, ${nombres.slice(-1)}`
      : `${nombres[0]}`;
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }
  private filtrarAsuntosPorNombreCorto() {

    const idAsuntoFiltrar = Constants.MAPA_NOMBRE_CORTO_A_ID[this.nombreCortoLimpio];

    if (!idAsuntoFiltrar) {
      console.warn('No se encontró un asunto para el nombreCorto:', this.nombreCortoLimpio);
      return;
    }

    setTimeout(() => {
      this.formClaseSolicitud = this.formClaseSolicitud.map(field => {

        if (field.name === 'asuntoField' && field.options?.length) {
          const opcionesFiltradas = field.options.filter(option => {
            return option.Id === idAsuntoFiltrar;
          });
          return { ...field, options: opcionesFiltradas };
        }

        return field;
      });
    }, 1000);
  }
  private asignarTituloKey() {
    this.tituloKey = Constants.MAPA_NOMBRE_CORTO_A_TITULO_KEY[this.nombreCortoLimpio] || 'titulo';
  }

  formulariosValidos(): boolean {
    if (this.formGroupClaseSolicitud?.valid
      && this.demandantes?.length > 0
      && this.demandados?.length > 0
      && this.formGroupDemandado?.valid
    ) {
      return true;
    } else {
      return false;
    }
  }
}
